/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SystemviewRouteImport } from './routes/systemview'
import { Route as ReconstructionRouteImport } from './routes/reconstruction'
import { Route as OkrDashboardRouteImport } from './routes/okr-dashboard'
import { Route as LandingRouteImport } from './routes/landing'
import { Route as KestrelRouteImport } from './routes/kestrel'
import { Route as JobsRouteImport } from './routes/jobs'
import { Route as HealthCheckRouteImport } from './routes/health-check'
import { Route as AerospaceGviRouteImport } from './routes/aerospace-gvi'
import { Route as PointCloudRouteRouteImport } from './routes/point-cloud/route'
import { Route as InspectionDashboardRouteRouteImport } from './routes/inspection-dashboard/route'
import { Route as ExplorerRouteRouteImport } from './routes/explorer/route'
import { Route as AvailabilityPlanningRouteRouteImport } from './routes/availability-planning.route'
import { Route as WeldmapIndexRouteImport } from './routes/weldmap.index'
import { Route as WalkthroughIndexRouteImport } from './routes/walkthrough/index'
import { Route as WalkdownsIndexRouteImport } from './routes/walkdowns/index'
import { Route as VirtualReportsIndexRouteImport } from './routes/virtual-reports/index'
import { Route as ViewerIndexRouteImport } from './routes/viewer/index'
import { Route as ViewerRoutingIndexRouteImport } from './routes/viewer-routing/index'
import { Route as ValueStoriesIndexRouteImport } from './routes/value-stories/index'
import { Route as UsersIndexRouteImport } from './routes/users/index'
import { Route as SystemLensIndexRouteImport } from './routes/system-lens/index'
import { Route as SiteContextMonitoringIndexRouteImport } from './routes/site-context-monitoring/index'
import { Route as ShipsIndexRouteImport } from './routes/ships/index'
import { Route as SchedulingIndexRouteImport } from './routes/scheduling/index'
import { Route as ReportingIndexRouteImport } from './routes/reporting/index'
import { Route as ProductionDashboardIndexRouteImport } from './routes/production-dashboard/index'
import { Route as ProcessFlowsIndexRouteImport } from './routes/process-flows/index'
import { Route as ProcessDataIndexRouteImport } from './routes/process-data/index'
import { Route as PrismIndexRouteImport } from './routes/prism/index'
import { Route as PointCloudIndexRouteImport } from './routes/point-cloud/index'
import { Route as PipelinesIndexRouteImport } from './routes/pipelines/index'
import { Route as PartsIndexRouteImport } from './routes/parts/index'
import { Route as OverviewIndexRouteImport } from './routes/overview/index'
import { Route as OrganizationIndexRouteImport } from './routes/organization/index'
import { Route as NotificationsIndexRouteImport } from './routes/notifications/index'
import { Route as NiiDashboardIndexRouteImport } from './routes/nii-dashboard.index'
import { Route as MaximoIndexRouteImport } from './routes/maximo/index'
import { Route as LogbookIndexRouteImport } from './routes/logbook/index'
import { Route as LibraIndexRouteImport } from './routes/libra/index'
import { Route as LibraDashboardIndexRouteImport } from './routes/libra-dashboard/index'
import { Route as KestrelIndexRouteImport } from './routes/kestrel.index'
import { Route as JobIndexRouteImport } from './routes/job/index'
import { Route as InspectionsIndexRouteImport } from './routes/inspections/index'
import { Route as InspectionDashboardIndexRouteImport } from './routes/inspection-dashboard/index'
import { Route as HomeIndexRouteImport } from './routes/home/index'
import { Route as HealthPlansIndexRouteImport } from './routes/health-plans/index'
import { Route as FlightDataUploadIndexRouteImport } from './routes/flightDataUpload/index'
import { Route as FleetAnalysisIndexRouteImport } from './routes/fleet-analysis/index'
import { Route as FimIndexRouteImport } from './routes/fim/index'
import { Route as ExtensionsIndexRouteImport } from './routes/extensions/index'
import { Route as ExplorerIndexRouteImport } from './routes/explorer/index'
import { Route as EntryBrowserIndexRouteImport } from './routes/entry-browser/index'
import { Route as DossiersIndexRouteImport } from './routes/dossiers/index'
import { Route as DocumentsIndexRouteImport } from './routes/documents/index'
import { Route as DocumentViewerIndexRouteImport } from './routes/document-viewer/index'
import { Route as CasesIndexRouteImport } from './routes/cases/index'
import { Route as BudgetingIndexRouteImport } from './routes/budgeting/index'
import { Route as AvailabilityPlanningIndexRouteImport } from './routes/availability-planning/index'
import { Route as AssetsIndexRouteImport } from './routes/assets/index'
import { Route as AssetLensIndexRouteImport } from './routes/asset-lens/index'
import { Route as AssetAssessmentIndexRouteImport } from './routes/asset-assessment/index'
import { Route as AppConfigIndexRouteImport } from './routes/app-config/index'
import { Route as AnomalyDetectionIndexRouteImport } from './routes/anomaly-detection/index'
import { Route as AlertsIndexRouteImport } from './routes/alerts/index'
import { Route as AerospaceGviIndexRouteImport } from './routes/aerospace-gvi.index'
import { Route as Fallback_routeIndexRouteImport } from './routes/_fallback_route/index'
import { Route as WeldmapKestrelModelIdRouteImport } from './routes/weldmap.$kestrelModelId'
import { Route as WalkdownsDetailsRouteImport } from './routes/walkdowns/details'
import { Route as VirtualReportsDetailsRouteImport } from './routes/virtual-reports/details'
import { Route as ValueStoriesEditRouteImport } from './routes/value-stories/edit'
import { Route as ValueStoriesDetailsRouteImport } from './routes/value-stories/details'
import { Route as ValueStoriesAddRouteImport } from './routes/value-stories/add'
import { Route as SystemviewEntryIDRouteImport } from './routes/systemview.$entryID'
import { Route as ReportingNewRouteImport } from './routes/reporting/new'
import { Route as ReportingDetailsRouteImport } from './routes/reporting/details'
import { Route as ProductionDashboardConfigRouteImport } from './routes/production-dashboard/config'
import { Route as ProcessFlowsDiagramRouteImport } from './routes/process-flows/diagram'
import { Route as ProcessDataViewRouteImport } from './routes/process-data/view'
import { Route as PointCloudViewRouteImport } from './routes/point-cloud/view'
import { Route as KestrelKestrelRolodexEntryRouteImport } from './routes/kestrel.$kestrelRolodexEntry'
import { Route as InspectionDashboardOrgOrSiteIDRouteImport } from './routes/inspection-dashboard/$orgOrSiteID'
import { Route as ForgingsIndicationsInspectionIdRouteImport } from './routes/forgings-indications.$inspectionId'
import { Route as FimReviewRouteImport } from './routes/fim/review'
import { Route as ExplorerOrgOrSiteIDRouteImport } from './routes/explorer/$orgOrSiteID'
import { Route as DocumentsUploadRouteImport } from './routes/documents/upload'
import { Route as DetailsEntryIDRouteImport } from './routes/details/$entryID'
import { Route as CasesEditRouteImport } from './routes/cases/edit'
import { Route as CasesDetailsRouteImport } from './routes/cases/details'
import { Route as AssetsRoutingRouteImport } from './routes/assets/routing'
import { Route as AnomalyDetectionConfigRouteImport } from './routes/anomaly-detection/config'
import { Route as AlertsDetailsRouteImport } from './routes/alerts/details'
import { Route as AerospaceGviInspectionIdRouteImport } from './routes/aerospace-gvi.$inspectionId'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminAccessRouteImport } from './routes/admin.access'
import { Route as ViewerUnitIDIndexRouteImport } from './routes/viewer/$unitID/index'
import { Route as OrganizationSiteIndexRouteImport } from './routes/organization_/site/index'
import { Route as Walkthroughdeprecated_routesSiteIDRouteImport } from './routes/walkthrough/(deprecated_routes)/$siteID'
import { Route as ViewerUnitIDInspectionRouteImport } from './routes/viewer/$unitID/inspection'
import { Route as ViewerUnitIDConfigurationRouteImport } from './routes/viewer/$unitID/configuration'
import { Route as Usersdeprecated_routesOrgIDRouteImport } from './routes/users/(deprecated_routes)/$orgID'
import { Route as SystemLensdeprecated_routesSiteIDRouteImport } from './routes/system-lens/(deprecated_routes)/$siteID'
import { Route as Schedulingdeprecated_routesSiteIDRouteImport } from './routes/scheduling/(deprecated_routes)/$siteID'
import { Route as ProcessDataChartChartIDRouteImport } from './routes/process-data/chart.$chartID'
import { Route as Partsdeprecated_routesSiteIDRouteImport } from './routes/parts/(deprecated_routes)/$siteID'
import { Route as Overviewdeprecated_routesSiteIDRouteImport } from './routes/overview/(deprecated_routes)/$siteID'
import { Route as Organizationdeprecated_routesOrgIDRouteImport } from './routes/organization/(deprecated_routes)/$orgID'
import { Route as Maximodeprecated_routesSiteIDRouteImport } from './routes/maximo/(deprecated_routes)/$siteID'
import { Route as LogbookTemplatesNewRouteImport } from './routes/logbook/templates.new'
import { Route as LogbookTemplatesTemplateIdRouteImport } from './routes/logbook/templates.$templateId'
import { Route as LogbookEntryNewRouteImport } from './routes/logbook/entry.new'
import { Route as LogbookEntryLogEntryIdRouteImport } from './routes/logbook/entry.$logEntryId'
import { Route as LibraDashboarddeprecated_routesOrgIDRouteImport } from './routes/libra-dashboard/(deprecated_routes)/$orgID'
import { Route as Jobdeprecated_routesSiteIDRouteImport } from './routes/job/(deprecated_routes)/$siteID'
import { Route as Inspectionsdeprecated_routesSiteIDRouteImport } from './routes/inspections/(deprecated_routes)/$siteID'
import { Route as Homedeprecated_routesChar123SiteIDChar125RouteImport } from './routes/home/(deprecated_routes)/{-$siteID}'
import { Route as HealthPlansdeprecated_routesSiteIDRouteImport } from './routes/health-plans/(deprecated_routes)/$siteID'
import { Route as FlightDataUploaddeprecated_routesSiteIDRouteImport } from './routes/flightDataUpload/(deprecated_routes)/$siteID'
import { Route as FleetAnalysisdeprecated_routesSiteIDRouteImport } from './routes/fleet-analysis/(deprecated_routes)/$siteID'
import { Route as Extensionsdeprecated_routesOrgIDRouteImport } from './routes/extensions/(deprecated_routes)/$orgID'
import { Route as Casesdeprecated_routesSiteIDRouteImport } from './routes/cases/(deprecated_routes)/$siteID'
import { Route as Budgetingdeprecated_routesSiteIDRouteImport } from './routes/budgeting/(deprecated_routes)/$siteID'
import { Route as AvailabilityPlanningdeprecated_routesSiteIDRouteImport } from './routes/availability-planning/(deprecated_routes)/$siteID'
import { Route as Assetssingle_asset_destinationsUnitRouteImport } from './routes/assets/(single_asset_destinations)/unit'
import { Route as Assetssingle_asset_destinationsLifecycleRouteImport } from './routes/assets/(single_asset_destinations)/lifecycle'
import { Route as Assetsdeprecated_routesChar123SiteIDChar125RouteImport } from './routes/assets/(deprecated_routes)/{-$siteID}'
import { Route as AnomalyDetectiondeprecated_routesSiteIDRouteImport } from './routes/anomaly-detection/(deprecated_routes)/$siteID'
import { Route as Alertsdeprecated_routesSiteIDRouteImport } from './routes/alerts/(deprecated_routes)/$siteID'
import { Route as deprecated_page_namesSiteViewSiteIDRouteImport } from './routes/(deprecated_page_names)/site-view.$siteID'
import { Route as Walkdownsdeprecated_routesSiteIDIndexRouteImport } from './routes/walkdowns/(deprecated_routes)/$siteID.index'
import { Route as VirtualReportsdeprecated_routesSiteIDIndexRouteImport } from './routes/virtual-reports/(deprecated_routes)/$siteID.index'
import { Route as ValueStoriesdeprecated_routesSiteIDIndexRouteImport } from './routes/value-stories/(deprecated_routes)/$siteID.index'
import { Route as Shipsdeprecated_routesSiteIDIndexRouteImport } from './routes/ships/(deprecated_routes)/$siteID.index'
import { Route as Reportingdeprecated_routesSiteIDIndexRouteImport } from './routes/reporting/(deprecated_routes)/$siteID.index'
import { Route as ProcessFlowsdeprecated_routesSiteIDIndexRouteImport } from './routes/process-flows/(deprecated_routes)/$siteID.index'
import { Route as ProcessDatadeprecated_routesSiteIDIndexRouteImport } from './routes/process-data/(deprecated_routes)/$siteID.index'
import { Route as Walkdownsdeprecated_routesSiteIDWalkdownIdRouteImport } from './routes/walkdowns/(deprecated_routes)/$siteID.$walkdownId'
import { Route as VirtualReportsdeprecated_routesSiteIDComponentIDRouteImport } from './routes/virtual-reports/(deprecated_routes)/$siteID.$componentID'
import { Route as ValueStoriesdeprecated_routesSiteIDAddRouteImport } from './routes/value-stories/(deprecated_routes)/$siteID.add'
import { Route as Reportingdeprecated_routesSiteIDNewRouteImport } from './routes/reporting/(deprecated_routes)/$siteID.new'
import { Route as Reportingdeprecated_routesSiteIDReportIDRouteImport } from './routes/reporting/(deprecated_routes)/$siteID.$reportID'
import { Route as ProcessFlowsdeprecated_routesSiteIDDiagramIDRouteImport } from './routes/process-flows/(deprecated_routes)/$siteID.$diagramID'
import { Route as ProcessDatadeprecated_routesSiteIDViewRouteImport } from './routes/process-data/(deprecated_routes)/$siteID.view'
import { Route as Prismdeprecated_routesOrgIDEntryIdRouteImport } from './routes/prism/(deprecated_routes)/$orgID.$entryId'
import { Route as PointClouddeprecated_routesSiteIDChar123PointCloudOrSceneIDChar125RouteImport } from './routes/point-cloud/(deprecated_routes)/$siteID.{-$pointCloudOrSceneID}'
import { Route as Organizationdeprecated_routesOrgIDSiteRouteImport } from './routes/organization_/(deprecated_routes)/$orgID.site'
import { Route as Libradeprecated_routesOrgIDChar123WorkflowIdChar125RouteImport } from './routes/libra/(deprecated_routes)/$orgID.{-$workflowId}'
import { Route as LibraDashboarddeprecated_routesOrgIDDashboardConfigIdRouteImport } from './routes/libra-dashboard/(deprecated_routes)/$orgID.$dashboardConfigId'
import { Route as KestrelFormsInspectionTypeFormNameRouteImport } from './routes/kestrel.forms.$inspectionType.$formName'
import { Route as Casesdeprecated_routesSiteIDCaseIDRouteImport } from './routes/cases/(deprecated_routes)/$siteID.$caseID'
import { Route as AvailabilityPlanningdeprecated_routesSiteIDShipIDRouteImport } from './routes/availability-planning/(deprecated_routes)/$siteID.$shipID'
import { Route as Assetsdeprecated_routesSiteIDUnitIDRouteImport } from './routes/assets/(deprecated_routes)/$siteID.$unitID'
import { Route as AssetLensdeprecated_routesSiteIDUnitIDRouteImport } from './routes/asset-lens/(deprecated_routes)/$siteID.$unitID'
import { Route as AssetAssessmentdeprecated_routesSiteIDChar123UnitIDChar125RouteImport } from './routes/asset-assessment/(deprecated_routes)/$siteID.{-$unitID}'
import { Route as AnomalyDetectiondeprecated_routesSiteIDDetectionConfigurationIdRouteImport } from './routes/anomaly-detection/(deprecated_routes)/$siteID.$detectionConfigurationId'
import { Route as ValueStoriesdeprecated_routesSiteIDValueStoryIDIndexRouteImport } from './routes/value-stories/(deprecated_routes)/$siteID.$valueStoryID.index'
import { Route as ProductionDashboarddeprecated_routesOrgIDSiteIDIndexRouteImport } from './routes/production-dashboard/(deprecated_routes)/$orgID.$siteID.index'
import { Route as ValueStoriesdeprecated_routesSiteIDValueStoryIDEditRouteImport } from './routes/value-stories/(deprecated_routes)/$siteID.$valueStoryID.edit'
import { Route as ProductionDashboarddeprecated_routesOrgIDSiteIDConfigIDRouteImport } from './routes/production-dashboard/(deprecated_routes)/$orgID.$siteID.$configID'
import { Route as ProcessDatadeprecated_routesSiteIDChartChartIDRouteImport } from './routes/process-data/(deprecated_routes)/$siteID.chart.$chartID'
import { Route as Organizationdeprecated_routesOrgIDSiteSiteIDRouteImport } from './routes/organization_/(deprecated_routes)/$orgID.site.$siteID'
import { Route as Casesdeprecated_routesSiteIDEditCaseIDRouteImport } from './routes/cases/(deprecated_routes)/$siteID.edit.$caseID'

const SystemviewRoute = SystemviewRouteImport.update({
  id: '/systemview',
  path: '/systemview',
  getParentRoute: () => rootRouteImport,
} as any)
const ReconstructionRoute = ReconstructionRouteImport.update({
  id: '/reconstruction',
  path: '/reconstruction',
  getParentRoute: () => rootRouteImport,
} as any)
const OkrDashboardRoute = OkrDashboardRouteImport.update({
  id: '/okr-dashboard',
  path: '/okr-dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const LandingRoute = LandingRouteImport.update({
  id: '/landing',
  path: '/landing',
  getParentRoute: () => rootRouteImport,
} as any)
const KestrelRoute = KestrelRouteImport.update({
  id: '/kestrel',
  path: '/kestrel',
  getParentRoute: () => rootRouteImport,
} as any)
const JobsRoute = JobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => rootRouteImport,
} as any)
const HealthCheckRoute = HealthCheckRouteImport.update({
  id: '/health-check',
  path: '/health-check',
  getParentRoute: () => rootRouteImport,
} as any)
const AerospaceGviRoute = AerospaceGviRouteImport.update({
  id: '/aerospace-gvi',
  path: '/aerospace-gvi',
  getParentRoute: () => rootRouteImport,
} as any)
const PointCloudRouteRoute = PointCloudRouteRouteImport.update({
  id: '/point-cloud',
  path: '/point-cloud',
  getParentRoute: () => rootRouteImport,
} as any)
const InspectionDashboardRouteRoute =
  InspectionDashboardRouteRouteImport.update({
    id: '/inspection-dashboard',
    path: '/inspection-dashboard',
    getParentRoute: () => rootRouteImport,
  } as any)
const ExplorerRouteRoute = ExplorerRouteRouteImport.update({
  id: '/explorer',
  path: '/explorer',
  getParentRoute: () => rootRouteImport,
} as any)
const AvailabilityPlanningRouteRoute =
  AvailabilityPlanningRouteRouteImport.update({
    id: '/availability-planning',
    path: '/availability-planning',
    getParentRoute: () => rootRouteImport,
  } as any)
const WeldmapIndexRoute = WeldmapIndexRouteImport.update({
  id: '/weldmap/',
  path: '/weldmap/',
  getParentRoute: () => rootRouteImport,
} as any)
const WalkthroughIndexRoute = WalkthroughIndexRouteImport.update({
  id: '/walkthrough/',
  path: '/walkthrough/',
  getParentRoute: () => rootRouteImport,
} as any)
const WalkdownsIndexRoute = WalkdownsIndexRouteImport.update({
  id: '/walkdowns/',
  path: '/walkdowns/',
  getParentRoute: () => rootRouteImport,
} as any)
const VirtualReportsIndexRoute = VirtualReportsIndexRouteImport.update({
  id: '/virtual-reports/',
  path: '/virtual-reports/',
  getParentRoute: () => rootRouteImport,
} as any)
const ViewerIndexRoute = ViewerIndexRouteImport.update({
  id: '/viewer/',
  path: '/viewer/',
  getParentRoute: () => rootRouteImport,
} as any)
const ViewerRoutingIndexRoute = ViewerRoutingIndexRouteImport.update({
  id: '/viewer-routing/',
  path: '/viewer-routing/',
  getParentRoute: () => rootRouteImport,
} as any)
const ValueStoriesIndexRoute = ValueStoriesIndexRouteImport.update({
  id: '/value-stories/',
  path: '/value-stories/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemLensIndexRoute = SystemLensIndexRouteImport.update({
  id: '/system-lens/',
  path: '/system-lens/',
  getParentRoute: () => rootRouteImport,
} as any)
const SiteContextMonitoringIndexRoute =
  SiteContextMonitoringIndexRouteImport.update({
    id: '/site-context-monitoring/',
    path: '/site-context-monitoring/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ShipsIndexRoute = ShipsIndexRouteImport.update({
  id: '/ships/',
  path: '/ships/',
  getParentRoute: () => rootRouteImport,
} as any)
const SchedulingIndexRoute = SchedulingIndexRouteImport.update({
  id: '/scheduling/',
  path: '/scheduling/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportingIndexRoute = ReportingIndexRouteImport.update({
  id: '/reporting/',
  path: '/reporting/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductionDashboardIndexRoute =
  ProductionDashboardIndexRouteImport.update({
    id: '/production-dashboard/',
    path: '/production-dashboard/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProcessFlowsIndexRoute = ProcessFlowsIndexRouteImport.update({
  id: '/process-flows/',
  path: '/process-flows/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProcessDataIndexRoute = ProcessDataIndexRouteImport.update({
  id: '/process-data/',
  path: '/process-data/',
  getParentRoute: () => rootRouteImport,
} as any)
const PrismIndexRoute = PrismIndexRouteImport.update({
  id: '/prism/',
  path: '/prism/',
  getParentRoute: () => rootRouteImport,
} as any)
const PointCloudIndexRoute = PointCloudIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PointCloudRouteRoute,
} as any)
const PipelinesIndexRoute = PipelinesIndexRouteImport.update({
  id: '/pipelines/',
  path: '/pipelines/',
  getParentRoute: () => rootRouteImport,
} as any)
const PartsIndexRoute = PartsIndexRouteImport.update({
  id: '/parts/',
  path: '/parts/',
  getParentRoute: () => rootRouteImport,
} as any)
const OverviewIndexRoute = OverviewIndexRouteImport.update({
  id: '/overview/',
  path: '/overview/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationIndexRoute = OrganizationIndexRouteImport.update({
  id: '/organization/',
  path: '/organization/',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsIndexRoute = NotificationsIndexRouteImport.update({
  id: '/notifications/',
  path: '/notifications/',
  getParentRoute: () => rootRouteImport,
} as any)
const NiiDashboardIndexRoute = NiiDashboardIndexRouteImport.update({
  id: '/nii-dashboard/',
  path: '/nii-dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const MaximoIndexRoute = MaximoIndexRouteImport.update({
  id: '/maximo/',
  path: '/maximo/',
  getParentRoute: () => rootRouteImport,
} as any)
const LogbookIndexRoute = LogbookIndexRouteImport.update({
  id: '/logbook/',
  path: '/logbook/',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraIndexRoute = LibraIndexRouteImport.update({
  id: '/libra/',
  path: '/libra/',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraDashboardIndexRoute = LibraDashboardIndexRouteImport.update({
  id: '/libra-dashboard/',
  path: '/libra-dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const KestrelIndexRoute = KestrelIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => KestrelRoute,
} as any)
const JobIndexRoute = JobIndexRouteImport.update({
  id: '/job/',
  path: '/job/',
  getParentRoute: () => rootRouteImport,
} as any)
const InspectionsIndexRoute = InspectionsIndexRouteImport.update({
  id: '/inspections/',
  path: '/inspections/',
  getParentRoute: () => rootRouteImport,
} as any)
const InspectionDashboardIndexRoute =
  InspectionDashboardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => InspectionDashboardRouteRoute,
  } as any)
const HomeIndexRoute = HomeIndexRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => rootRouteImport,
} as any)
const HealthPlansIndexRoute = HealthPlansIndexRouteImport.update({
  id: '/health-plans/',
  path: '/health-plans/',
  getParentRoute: () => rootRouteImport,
} as any)
const FlightDataUploadIndexRoute = FlightDataUploadIndexRouteImport.update({
  id: '/flightDataUpload/',
  path: '/flightDataUpload/',
  getParentRoute: () => rootRouteImport,
} as any)
const FleetAnalysisIndexRoute = FleetAnalysisIndexRouteImport.update({
  id: '/fleet-analysis/',
  path: '/fleet-analysis/',
  getParentRoute: () => rootRouteImport,
} as any)
const FimIndexRoute = FimIndexRouteImport.update({
  id: '/fim/',
  path: '/fim/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExtensionsIndexRoute = ExtensionsIndexRouteImport.update({
  id: '/extensions/',
  path: '/extensions/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExplorerIndexRoute = ExplorerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ExplorerRouteRoute,
} as any)
const EntryBrowserIndexRoute = EntryBrowserIndexRouteImport.update({
  id: '/entry-browser/',
  path: '/entry-browser/',
  getParentRoute: () => rootRouteImport,
} as any)
const DossiersIndexRoute = DossiersIndexRouteImport.update({
  id: '/dossiers/',
  path: '/dossiers/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsIndexRoute = DocumentsIndexRouteImport.update({
  id: '/documents/',
  path: '/documents/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentViewerIndexRoute = DocumentViewerIndexRouteImport.update({
  id: '/document-viewer/',
  path: '/document-viewer/',
  getParentRoute: () => rootRouteImport,
} as any)
const CasesIndexRoute = CasesIndexRouteImport.update({
  id: '/cases/',
  path: '/cases/',
  getParentRoute: () => rootRouteImport,
} as any)
const BudgetingIndexRoute = BudgetingIndexRouteImport.update({
  id: '/budgeting/',
  path: '/budgeting/',
  getParentRoute: () => rootRouteImport,
} as any)
const AvailabilityPlanningIndexRoute =
  AvailabilityPlanningIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AvailabilityPlanningRouteRoute,
  } as any)
const AssetsIndexRoute = AssetsIndexRouteImport.update({
  id: '/assets/',
  path: '/assets/',
  getParentRoute: () => rootRouteImport,
} as any)
const AssetLensIndexRoute = AssetLensIndexRouteImport.update({
  id: '/asset-lens/',
  path: '/asset-lens/',
  getParentRoute: () => rootRouteImport,
} as any)
const AssetAssessmentIndexRoute = AssetAssessmentIndexRouteImport.update({
  id: '/asset-assessment/',
  path: '/asset-assessment/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppConfigIndexRoute = AppConfigIndexRouteImport.update({
  id: '/app-config/',
  path: '/app-config/',
  getParentRoute: () => rootRouteImport,
} as any)
const AnomalyDetectionIndexRoute = AnomalyDetectionIndexRouteImport.update({
  id: '/anomaly-detection/',
  path: '/anomaly-detection/',
  getParentRoute: () => rootRouteImport,
} as any)
const AlertsIndexRoute = AlertsIndexRouteImport.update({
  id: '/alerts/',
  path: '/alerts/',
  getParentRoute: () => rootRouteImport,
} as any)
const AerospaceGviIndexRoute = AerospaceGviIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AerospaceGviRoute,
} as any)
const Fallback_routeIndexRoute = Fallback_routeIndexRouteImport.update({
  id: '/_fallback_route/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WeldmapKestrelModelIdRoute = WeldmapKestrelModelIdRouteImport.update({
  id: '/weldmap/$kestrelModelId',
  path: '/weldmap/$kestrelModelId',
  getParentRoute: () => rootRouteImport,
} as any)
const WalkdownsDetailsRoute = WalkdownsDetailsRouteImport.update({
  id: '/walkdowns/details',
  path: '/walkdowns/details',
  getParentRoute: () => rootRouteImport,
} as any)
const VirtualReportsDetailsRoute = VirtualReportsDetailsRouteImport.update({
  id: '/virtual-reports/details',
  path: '/virtual-reports/details',
  getParentRoute: () => rootRouteImport,
} as any)
const ValueStoriesEditRoute = ValueStoriesEditRouteImport.update({
  id: '/value-stories/edit',
  path: '/value-stories/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const ValueStoriesDetailsRoute = ValueStoriesDetailsRouteImport.update({
  id: '/value-stories/details',
  path: '/value-stories/details',
  getParentRoute: () => rootRouteImport,
} as any)
const ValueStoriesAddRoute = ValueStoriesAddRouteImport.update({
  id: '/value-stories/add',
  path: '/value-stories/add',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemviewEntryIDRoute = SystemviewEntryIDRouteImport.update({
  id: '/$entryID',
  path: '/$entryID',
  getParentRoute: () => SystemviewRoute,
} as any)
const ReportingNewRoute = ReportingNewRouteImport.update({
  id: '/reporting/new',
  path: '/reporting/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportingDetailsRoute = ReportingDetailsRouteImport.update({
  id: '/reporting/details',
  path: '/reporting/details',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductionDashboardConfigRoute =
  ProductionDashboardConfigRouteImport.update({
    id: '/production-dashboard/config',
    path: '/production-dashboard/config',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProcessFlowsDiagramRoute = ProcessFlowsDiagramRouteImport.update({
  id: '/process-flows/diagram',
  path: '/process-flows/diagram',
  getParentRoute: () => rootRouteImport,
} as any)
const ProcessDataViewRoute = ProcessDataViewRouteImport.update({
  id: '/process-data/view',
  path: '/process-data/view',
  getParentRoute: () => rootRouteImport,
} as any)
const PointCloudViewRoute = PointCloudViewRouteImport.update({
  id: '/view',
  path: '/view',
  getParentRoute: () => PointCloudRouteRoute,
} as any)
const KestrelKestrelRolodexEntryRoute =
  KestrelKestrelRolodexEntryRouteImport.update({
    id: '/$kestrelRolodexEntry',
    path: '/$kestrelRolodexEntry',
    getParentRoute: () => KestrelRoute,
  } as any)
const InspectionDashboardOrgOrSiteIDRoute =
  InspectionDashboardOrgOrSiteIDRouteImport.update({
    id: '/$orgOrSiteID',
    path: '/$orgOrSiteID',
    getParentRoute: () => InspectionDashboardRouteRoute,
  } as any)
const ForgingsIndicationsInspectionIdRoute =
  ForgingsIndicationsInspectionIdRouteImport.update({
    id: '/forgings-indications/$inspectionId',
    path: '/forgings-indications/$inspectionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const FimReviewRoute = FimReviewRouteImport.update({
  id: '/fim/review',
  path: '/fim/review',
  getParentRoute: () => rootRouteImport,
} as any)
const ExplorerOrgOrSiteIDRoute = ExplorerOrgOrSiteIDRouteImport.update({
  id: '/$orgOrSiteID',
  path: '/$orgOrSiteID',
  getParentRoute: () => ExplorerRouteRoute,
} as any)
const DocumentsUploadRoute = DocumentsUploadRouteImport.update({
  id: '/documents/upload',
  path: '/documents/upload',
  getParentRoute: () => rootRouteImport,
} as any)
const DetailsEntryIDRoute = DetailsEntryIDRouteImport.update({
  id: '/details/$entryID',
  path: '/details/$entryID',
  getParentRoute: () => rootRouteImport,
} as any)
const CasesEditRoute = CasesEditRouteImport.update({
  id: '/cases/edit',
  path: '/cases/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const CasesDetailsRoute = CasesDetailsRouteImport.update({
  id: '/cases/details',
  path: '/cases/details',
  getParentRoute: () => rootRouteImport,
} as any)
const AssetsRoutingRoute = AssetsRoutingRouteImport.update({
  id: '/assets/routing',
  path: '/assets/routing',
  getParentRoute: () => rootRouteImport,
} as any)
const AnomalyDetectionConfigRoute = AnomalyDetectionConfigRouteImport.update({
  id: '/anomaly-detection/config',
  path: '/anomaly-detection/config',
  getParentRoute: () => rootRouteImport,
} as any)
const AlertsDetailsRoute = AlertsDetailsRouteImport.update({
  id: '/alerts/details',
  path: '/alerts/details',
  getParentRoute: () => rootRouteImport,
} as any)
const AerospaceGviInspectionIdRoute =
  AerospaceGviInspectionIdRouteImport.update({
    id: '/$inspectionId',
    path: '/$inspectionId',
    getParentRoute: () => AerospaceGviRoute,
  } as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAccessRoute = AdminAccessRouteImport.update({
  id: '/admin/access',
  path: '/admin/access',
  getParentRoute: () => rootRouteImport,
} as any)
const ViewerUnitIDIndexRoute = ViewerUnitIDIndexRouteImport.update({
  id: '/viewer/$unitID/',
  path: '/viewer/$unitID/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationSiteIndexRoute = OrganizationSiteIndexRouteImport.update({
  id: '/organization_/site/',
  path: '/organization/site/',
  getParentRoute: () => rootRouteImport,
} as any)
const Walkthroughdeprecated_routesSiteIDRoute =
  Walkthroughdeprecated_routesSiteIDRouteImport.update({
    id: '/walkthrough/(deprecated_routes)/$siteID',
    path: '/walkthrough/$siteID',
    getParentRoute: () => rootRouteImport,
  } as any)
const ViewerUnitIDInspectionRoute = ViewerUnitIDInspectionRouteImport.update({
  id: '/viewer/$unitID/inspection',
  path: '/viewer/$unitID/inspection',
  getParentRoute: () => rootRouteImport,
} as any)
const ViewerUnitIDConfigurationRoute =
  ViewerUnitIDConfigurationRouteImport.update({
    id: '/viewer/$unitID/configuration',
    path: '/viewer/$unitID/configuration',
    getParentRoute: () => rootRouteImport,
  } as any)
const Usersdeprecated_routesOrgIDRoute =
  Usersdeprecated_routesOrgIDRouteImport.update({
    id: '/users/(deprecated_routes)/$orgID',
    path: '/users/$orgID',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemLensdeprecated_routesSiteIDRoute =
  SystemLensdeprecated_routesSiteIDRouteImport.update({
    id: '/system-lens/(deprecated_routes)/$siteID',
    path: '/system-lens/$siteID',
    getParentRoute: () => rootRouteImport,
  } as any)
const Schedulingdeprecated_routesSiteIDRoute =
  Schedulingdeprecated_routesSiteIDRouteImport.update({
    id: '/scheduling/(deprecated_routes)/$siteID',
    path: '/scheduling/$siteID',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProcessDataChartChartIDRoute = ProcessDataChartChartIDRouteImport.update({
  id: '/process-data/chart/$chartID',
  path: '/process-data/chart/$chartID',
  getParentRoute: () => rootRouteImport,
} as any)
const Partsdeprecated_routesSiteIDRoute =
  Partsdeprecated_routesSiteIDRouteImport.update({
    id: '/parts/(deprecated_routes)/$siteID',
    path: '/parts/$siteID',
    getParentRoute: () => rootRouteImport,
  } as any)
const Overviewdeprecated_routesSiteIDRoute =
  Overviewdeprecated_routesSiteIDRouteImport.update({
    id: '/overview/(deprecated_routes)/$siteID',
    path: '/overview/$siteID',
    getParentRoute: () => rootRouteImport,
  } as any)
const Organizationdeprecated_routesOrgIDRoute =
  Organizationdeprecated_routesOrgIDRouteImport.update({
    id: '/organization/(deprecated_routes)/$orgID',
    path: '/organization/$orgID',
    getParentRoute: () => rootRouteImport,
  } as any)
const Maximodeprecated_routesSiteIDRoute =
  Maximodeprecated_routesSiteIDRouteImport.update({
    id: '/maximo/(deprecated_routes)/$siteID',
    path: '/maximo/$siteID',
    getParentRoute: () => rootRouteImport,
  } as any)
const LogbookTemplatesNewRoute = LogbookTemplatesNewRouteImport.update({
  id: '/logbook/templates/new',
  path: '/logbook/templates/new',
  getParentRoute: () => rootRouteImport,
} as any)
const LogbookTemplatesTemplateIdRoute =
  LogbookTemplatesTemplateIdRouteImport.update({
    id: '/logbook/templates/$templateId',
    path: '/logbook/templates/$templateId',
    getParentRoute: () => rootRouteImport,
  } as any)
const LogbookEntryNewRoute = LogbookEntryNewRouteImport.update({
  id: '/logbook/entry/new',
  path: '/logbook/entry/new',
  getParentRoute: () => rootRouteImport,
} as any)
const LogbookEntryLogEntryIdRoute = LogbookEntryLogEntryIdRouteImport.update({
  id: '/logbook/entry/$logEntryId',
  path: '/logbook/entry/$logEntryId',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraDashboarddeprecated_routesOrgIDRoute =
  LibraDashboarddeprecated_routesOrgIDRouteImport.update({
    id: '/libra-dashboard/(deprecated_routes)/$orgID',
    path: '/libra-dashboard/$orgID',
    getParentRoute: () => rootRouteImport,
  } as any)
const Jobdeprecated_routesSiteIDRoute =
  Jobdeprecated_routesSiteIDRouteImport.update({
    id: '/job/(deprecated_routes)/$siteID',
    path: '/job/$siteID',
    getParentRoute: () => rootRouteImport,
  } as any)
const Inspectionsdeprecated_routesSiteIDRoute =
  Inspectionsdeprecated_routesSiteIDRouteImport.update({
    id: '/inspections/(deprecated_routes)/$siteID',
    path: '/inspections/$siteID',
    getParentRoute: () => rootRouteImport,
  } as any)
const Homedeprecated_routesChar123SiteIDChar125Route =
  Homedeprecated_routesChar123SiteIDChar125RouteImport.update({
    id: '/home/(deprecated_routes)/{-$siteID}',
    path: '/home/{-$siteID}',
    getParentRoute: () => rootRouteImport,
  } as any)
const HealthPlansdeprecated_routesSiteIDRoute =
  HealthPlansdeprecated_routesSiteIDRouteImport.update({
    id: '/health-plans/(deprecated_routes)/$siteID',
    path: '/health-plans/$siteID',
    getParentRoute: () => rootRouteImport,
  } as any)
const FlightDataUploaddeprecated_routesSiteIDRoute =
  FlightDataUploaddeprecated_routesSiteIDRouteImport.update({
    id: '/flightDataUpload/(deprecated_routes)/$siteID',
    path: '/flightDataUpload/$siteID',
    getParentRoute: () => rootRouteImport,
  } as any)
const FleetAnalysisdeprecated_routesSiteIDRoute =
  FleetAnalysisdeprecated_routesSiteIDRouteImport.update({
    id: '/fleet-analysis/(deprecated_routes)/$siteID',
    path: '/fleet-analysis/$siteID',
    getParentRoute: () => rootRouteImport,
  } as any)
const Extensionsdeprecated_routesOrgIDRoute =
  Extensionsdeprecated_routesOrgIDRouteImport.update({
    id: '/extensions/(deprecated_routes)/$orgID',
    path: '/extensions/$orgID',
    getParentRoute: () => rootRouteImport,
  } as any)
const Casesdeprecated_routesSiteIDRoute =
  Casesdeprecated_routesSiteIDRouteImport.update({
    id: '/cases/(deprecated_routes)/$siteID',
    path: '/cases/$siteID',
    getParentRoute: () => rootRouteImport,
  } as any)
const Budgetingdeprecated_routesSiteIDRoute =
  Budgetingdeprecated_routesSiteIDRouteImport.update({
    id: '/budgeting/(deprecated_routes)/$siteID',
    path: '/budgeting/$siteID',
    getParentRoute: () => rootRouteImport,
  } as any)
const AvailabilityPlanningdeprecated_routesSiteIDRoute =
  AvailabilityPlanningdeprecated_routesSiteIDRouteImport.update({
    id: '/(deprecated_routes)/$siteID',
    path: '/$siteID',
    getParentRoute: () => AvailabilityPlanningRouteRoute,
  } as any)
const Assetssingle_asset_destinationsUnitRoute =
  Assetssingle_asset_destinationsUnitRouteImport.update({
    id: '/assets/(single_asset_destinations)/unit',
    path: '/assets/unit',
    getParentRoute: () => rootRouteImport,
  } as any)
const Assetssingle_asset_destinationsLifecycleRoute =
  Assetssingle_asset_destinationsLifecycleRouteImport.update({
    id: '/assets/(single_asset_destinations)/lifecycle',
    path: '/assets/lifecycle',
    getParentRoute: () => rootRouteImport,
  } as any)
const Assetsdeprecated_routesChar123SiteIDChar125Route =
  Assetsdeprecated_routesChar123SiteIDChar125RouteImport.update({
    id: '/assets/(deprecated_routes)/{-$siteID}',
    path: '/assets/{-$siteID}',
    getParentRoute: () => rootRouteImport,
  } as any)
const AnomalyDetectiondeprecated_routesSiteIDRoute =
  AnomalyDetectiondeprecated_routesSiteIDRouteImport.update({
    id: '/anomaly-detection/(deprecated_routes)/$siteID',
    path: '/anomaly-detection/$siteID',
    getParentRoute: () => rootRouteImport,
  } as any)
const Alertsdeprecated_routesSiteIDRoute =
  Alertsdeprecated_routesSiteIDRouteImport.update({
    id: '/alerts/(deprecated_routes)/$siteID',
    path: '/alerts/$siteID',
    getParentRoute: () => rootRouteImport,
  } as any)
const deprecated_page_namesSiteViewSiteIDRoute =
  deprecated_page_namesSiteViewSiteIDRouteImport.update({
    id: '/(deprecated_page_names)/site-view/$siteID',
    path: '/site-view/$siteID',
    getParentRoute: () => rootRouteImport,
  } as any)
const Walkdownsdeprecated_routesSiteIDIndexRoute =
  Walkdownsdeprecated_routesSiteIDIndexRouteImport.update({
    id: '/walkdowns/(deprecated_routes)/$siteID/',
    path: '/walkdowns/$siteID/',
    getParentRoute: () => rootRouteImport,
  } as any)
const VirtualReportsdeprecated_routesSiteIDIndexRoute =
  VirtualReportsdeprecated_routesSiteIDIndexRouteImport.update({
    id: '/virtual-reports/(deprecated_routes)/$siteID/',
    path: '/virtual-reports/$siteID/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ValueStoriesdeprecated_routesSiteIDIndexRoute =
  ValueStoriesdeprecated_routesSiteIDIndexRouteImport.update({
    id: '/value-stories/(deprecated_routes)/$siteID/',
    path: '/value-stories/$siteID/',
    getParentRoute: () => rootRouteImport,
  } as any)
const Shipsdeprecated_routesSiteIDIndexRoute =
  Shipsdeprecated_routesSiteIDIndexRouteImport.update({
    id: '/ships/(deprecated_routes)/$siteID/',
    path: '/ships/$siteID/',
    getParentRoute: () => rootRouteImport,
  } as any)
const Reportingdeprecated_routesSiteIDIndexRoute =
  Reportingdeprecated_routesSiteIDIndexRouteImport.update({
    id: '/reporting/(deprecated_routes)/$siteID/',
    path: '/reporting/$siteID/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProcessFlowsdeprecated_routesSiteIDIndexRoute =
  ProcessFlowsdeprecated_routesSiteIDIndexRouteImport.update({
    id: '/process-flows/(deprecated_routes)/$siteID/',
    path: '/process-flows/$siteID/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProcessDatadeprecated_routesSiteIDIndexRoute =
  ProcessDatadeprecated_routesSiteIDIndexRouteImport.update({
    id: '/process-data/(deprecated_routes)/$siteID/',
    path: '/process-data/$siteID/',
    getParentRoute: () => rootRouteImport,
  } as any)
const Walkdownsdeprecated_routesSiteIDWalkdownIdRoute =
  Walkdownsdeprecated_routesSiteIDWalkdownIdRouteImport.update({
    id: '/walkdowns/(deprecated_routes)/$siteID/$walkdownId',
    path: '/walkdowns/$siteID/$walkdownId',
    getParentRoute: () => rootRouteImport,
  } as any)
const VirtualReportsdeprecated_routesSiteIDComponentIDRoute =
  VirtualReportsdeprecated_routesSiteIDComponentIDRouteImport.update({
    id: '/virtual-reports/(deprecated_routes)/$siteID/$componentID',
    path: '/virtual-reports/$siteID/$componentID',
    getParentRoute: () => rootRouteImport,
  } as any)
const ValueStoriesdeprecated_routesSiteIDAddRoute =
  ValueStoriesdeprecated_routesSiteIDAddRouteImport.update({
    id: '/value-stories/(deprecated_routes)/$siteID/add',
    path: '/value-stories/$siteID/add',
    getParentRoute: () => rootRouteImport,
  } as any)
const Reportingdeprecated_routesSiteIDNewRoute =
  Reportingdeprecated_routesSiteIDNewRouteImport.update({
    id: '/reporting/(deprecated_routes)/$siteID/new',
    path: '/reporting/$siteID/new',
    getParentRoute: () => rootRouteImport,
  } as any)
const Reportingdeprecated_routesSiteIDReportIDRoute =
  Reportingdeprecated_routesSiteIDReportIDRouteImport.update({
    id: '/reporting/(deprecated_routes)/$siteID/$reportID',
    path: '/reporting/$siteID/$reportID',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProcessFlowsdeprecated_routesSiteIDDiagramIDRoute =
  ProcessFlowsdeprecated_routesSiteIDDiagramIDRouteImport.update({
    id: '/process-flows/(deprecated_routes)/$siteID/$diagramID',
    path: '/process-flows/$siteID/$diagramID',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProcessDatadeprecated_routesSiteIDViewRoute =
  ProcessDatadeprecated_routesSiteIDViewRouteImport.update({
    id: '/process-data/(deprecated_routes)/$siteID/view',
    path: '/process-data/$siteID/view',
    getParentRoute: () => rootRouteImport,
  } as any)
const Prismdeprecated_routesOrgIDEntryIdRoute =
  Prismdeprecated_routesOrgIDEntryIdRouteImport.update({
    id: '/prism/(deprecated_routes)/$orgID/$entryId',
    path: '/prism/$orgID/$entryId',
    getParentRoute: () => rootRouteImport,
  } as any)
const PointClouddeprecated_routesSiteIDChar123PointCloudOrSceneIDChar125Route =
  PointClouddeprecated_routesSiteIDChar123PointCloudOrSceneIDChar125RouteImport.update(
    {
      id: '/(deprecated_routes)/$siteID/{-$pointCloudOrSceneID}',
      path: '/$siteID/{-$pointCloudOrSceneID}',
      getParentRoute: () => PointCloudRouteRoute,
    } as any,
  )
const Organizationdeprecated_routesOrgIDSiteRoute =
  Organizationdeprecated_routesOrgIDSiteRouteImport.update({
    id: '/organization_/(deprecated_routes)/$orgID/site',
    path: '/organization/$orgID/site',
    getParentRoute: () => rootRouteImport,
  } as any)
const Libradeprecated_routesOrgIDChar123WorkflowIdChar125Route =
  Libradeprecated_routesOrgIDChar123WorkflowIdChar125RouteImport.update({
    id: '/libra/(deprecated_routes)/$orgID/{-$workflowId}',
    path: '/libra/$orgID/{-$workflowId}',
    getParentRoute: () => rootRouteImport,
  } as any)
const LibraDashboarddeprecated_routesOrgIDDashboardConfigIdRoute =
  LibraDashboarddeprecated_routesOrgIDDashboardConfigIdRouteImport.update({
    id: '/$dashboardConfigId',
    path: '/$dashboardConfigId',
    getParentRoute: () => LibraDashboarddeprecated_routesOrgIDRoute,
  } as any)
const KestrelFormsInspectionTypeFormNameRoute =
  KestrelFormsInspectionTypeFormNameRouteImport.update({
    id: '/forms/$inspectionType/$formName',
    path: '/forms/$inspectionType/$formName',
    getParentRoute: () => KestrelRoute,
  } as any)
const Casesdeprecated_routesSiteIDCaseIDRoute =
  Casesdeprecated_routesSiteIDCaseIDRouteImport.update({
    id: '/$caseID',
    path: '/$caseID',
    getParentRoute: () => Casesdeprecated_routesSiteIDRoute,
  } as any)
const AvailabilityPlanningdeprecated_routesSiteIDShipIDRoute =
  AvailabilityPlanningdeprecated_routesSiteIDShipIDRouteImport.update({
    id: '/$shipID',
    path: '/$shipID',
    getParentRoute: () => AvailabilityPlanningdeprecated_routesSiteIDRoute,
  } as any)
const Assetsdeprecated_routesSiteIDUnitIDRoute =
  Assetsdeprecated_routesSiteIDUnitIDRouteImport.update({
    id: '/assets/(deprecated_routes)/$siteID/$unitID',
    path: '/assets/$siteID/$unitID',
    getParentRoute: () => rootRouteImport,
  } as any)
const AssetLensdeprecated_routesSiteIDUnitIDRoute =
  AssetLensdeprecated_routesSiteIDUnitIDRouteImport.update({
    id: '/asset-lens/(deprecated_routes)/$siteID/$unitID',
    path: '/asset-lens/$siteID/$unitID',
    getParentRoute: () => rootRouteImport,
  } as any)
const AssetAssessmentdeprecated_routesSiteIDChar123UnitIDChar125Route =
  AssetAssessmentdeprecated_routesSiteIDChar123UnitIDChar125RouteImport.update({
    id: '/asset-assessment/(deprecated_routes)/$siteID/{-$unitID}',
    path: '/asset-assessment/$siteID/{-$unitID}',
    getParentRoute: () => rootRouteImport,
  } as any)
const AnomalyDetectiondeprecated_routesSiteIDDetectionConfigurationIdRoute =
  AnomalyDetectiondeprecated_routesSiteIDDetectionConfigurationIdRouteImport.update(
    {
      id: '/$detectionConfigurationId',
      path: '/$detectionConfigurationId',
      getParentRoute: () => AnomalyDetectiondeprecated_routesSiteIDRoute,
    } as any,
  )
const ValueStoriesdeprecated_routesSiteIDValueStoryIDIndexRoute =
  ValueStoriesdeprecated_routesSiteIDValueStoryIDIndexRouteImport.update({
    id: '/value-stories/(deprecated_routes)/$siteID/$valueStoryID/',
    path: '/value-stories/$siteID/$valueStoryID/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProductionDashboarddeprecated_routesOrgIDSiteIDIndexRoute =
  ProductionDashboarddeprecated_routesOrgIDSiteIDIndexRouteImport.update({
    id: '/production-dashboard/(deprecated_routes)/$orgID/$siteID/',
    path: '/production-dashboard/$orgID/$siteID/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ValueStoriesdeprecated_routesSiteIDValueStoryIDEditRoute =
  ValueStoriesdeprecated_routesSiteIDValueStoryIDEditRouteImport.update({
    id: '/value-stories/(deprecated_routes)/$siteID/$valueStoryID/edit',
    path: '/value-stories/$siteID/$valueStoryID/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProductionDashboarddeprecated_routesOrgIDSiteIDConfigIDRoute =
  ProductionDashboarddeprecated_routesOrgIDSiteIDConfigIDRouteImport.update({
    id: '/production-dashboard/(deprecated_routes)/$orgID/$siteID/$configID',
    path: '/production-dashboard/$orgID/$siteID/$configID',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProcessDatadeprecated_routesSiteIDChartChartIDRoute =
  ProcessDatadeprecated_routesSiteIDChartChartIDRouteImport.update({
    id: '/process-data/(deprecated_routes)/$siteID/chart/$chartID',
    path: '/process-data/$siteID/chart/$chartID',
    getParentRoute: () => rootRouteImport,
  } as any)
const Organizationdeprecated_routesOrgIDSiteSiteIDRoute =
  Organizationdeprecated_routesOrgIDSiteSiteIDRouteImport.update({
    id: '/$siteID',
    path: '/$siteID',
    getParentRoute: () => Organizationdeprecated_routesOrgIDSiteRoute,
  } as any)
const Casesdeprecated_routesSiteIDEditCaseIDRoute =
  Casesdeprecated_routesSiteIDEditCaseIDRouteImport.update({
    id: '/edit/$caseID',
    path: '/edit/$caseID',
    getParentRoute: () => Casesdeprecated_routesSiteIDRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/availability-planning': typeof AvailabilityPlanningRouteRouteWithChildren
  '/explorer': typeof ExplorerRouteRouteWithChildren
  '/inspection-dashboard': typeof InspectionDashboardRouteRouteWithChildren
  '/point-cloud': typeof PointCloudRouteRouteWithChildren
  '/aerospace-gvi': typeof AerospaceGviRouteWithChildren
  '/health-check': typeof HealthCheckRoute
  '/jobs': typeof JobsRoute
  '/kestrel': typeof KestrelRouteWithChildren
  '/landing': typeof LandingRoute
  '/okr-dashboard': typeof OkrDashboardRoute
  '/reconstruction': typeof ReconstructionRoute
  '/systemview': typeof SystemviewRouteWithChildren
  '/admin/access': typeof AdminAccessRoute
  '/admin/users': typeof AdminUsersRoute
  '/aerospace-gvi/$inspectionId': typeof AerospaceGviInspectionIdRoute
  '/alerts/details': typeof AlertsDetailsRoute
  '/anomaly-detection/config': typeof AnomalyDetectionConfigRoute
  '/assets/routing': typeof AssetsRoutingRoute
  '/cases/details': typeof CasesDetailsRoute
  '/cases/edit': typeof CasesEditRoute
  '/details/$entryID': typeof DetailsEntryIDRoute
  '/documents/upload': typeof DocumentsUploadRoute
  '/explorer/$orgOrSiteID': typeof ExplorerOrgOrSiteIDRoute
  '/fim/review': typeof FimReviewRoute
  '/forgings-indications/$inspectionId': typeof ForgingsIndicationsInspectionIdRoute
  '/inspection-dashboard/$orgOrSiteID': typeof InspectionDashboardOrgOrSiteIDRoute
  '/kestrel/$kestrelRolodexEntry': typeof KestrelKestrelRolodexEntryRoute
  '/point-cloud/view': typeof PointCloudViewRoute
  '/process-data/view': typeof ProcessDataViewRoute
  '/process-flows/diagram': typeof ProcessFlowsDiagramRoute
  '/production-dashboard/config': typeof ProductionDashboardConfigRoute
  '/reporting/details': typeof ReportingDetailsRoute
  '/reporting/new': typeof ReportingNewRoute
  '/systemview/$entryID': typeof SystemviewEntryIDRoute
  '/value-stories/add': typeof ValueStoriesAddRoute
  '/value-stories/details': typeof ValueStoriesDetailsRoute
  '/value-stories/edit': typeof ValueStoriesEditRoute
  '/virtual-reports/details': typeof VirtualReportsDetailsRoute
  '/walkdowns/details': typeof WalkdownsDetailsRoute
  '/weldmap/$kestrelModelId': typeof WeldmapKestrelModelIdRoute
  '/': typeof Fallback_routeIndexRoute
  '/aerospace-gvi/': typeof AerospaceGviIndexRoute
  '/alerts/': typeof AlertsIndexRoute
  '/anomaly-detection/': typeof AnomalyDetectionIndexRoute
  '/app-config/': typeof AppConfigIndexRoute
  '/asset-assessment/': typeof AssetAssessmentIndexRoute
  '/asset-lens/': typeof AssetLensIndexRoute
  '/assets/': typeof AssetsIndexRoute
  '/availability-planning/': typeof AvailabilityPlanningIndexRoute
  '/budgeting/': typeof BudgetingIndexRoute
  '/cases/': typeof CasesIndexRoute
  '/document-viewer/': typeof DocumentViewerIndexRoute
  '/documents/': typeof DocumentsIndexRoute
  '/dossiers/': typeof DossiersIndexRoute
  '/entry-browser/': typeof EntryBrowserIndexRoute
  '/explorer/': typeof ExplorerIndexRoute
  '/extensions/': typeof ExtensionsIndexRoute
  '/fim/': typeof FimIndexRoute
  '/fleet-analysis/': typeof FleetAnalysisIndexRoute
  '/flightDataUpload/': typeof FlightDataUploadIndexRoute
  '/health-plans/': typeof HealthPlansIndexRoute
  '/home/': typeof HomeIndexRoute
  '/inspection-dashboard/': typeof InspectionDashboardIndexRoute
  '/inspections/': typeof InspectionsIndexRoute
  '/job/': typeof JobIndexRoute
  '/kestrel/': typeof KestrelIndexRoute
  '/libra-dashboard/': typeof LibraDashboardIndexRoute
  '/libra/': typeof LibraIndexRoute
  '/logbook/': typeof LogbookIndexRoute
  '/maximo/': typeof MaximoIndexRoute
  '/nii-dashboard/': typeof NiiDashboardIndexRoute
  '/notifications/': typeof NotificationsIndexRoute
  '/organization/': typeof OrganizationIndexRoute
  '/overview/': typeof OverviewIndexRoute
  '/parts/': typeof PartsIndexRoute
  '/pipelines/': typeof PipelinesIndexRoute
  '/point-cloud/': typeof PointCloudIndexRoute
  '/prism/': typeof PrismIndexRoute
  '/process-data/': typeof ProcessDataIndexRoute
  '/process-flows/': typeof ProcessFlowsIndexRoute
  '/production-dashboard/': typeof ProductionDashboardIndexRoute
  '/reporting/': typeof ReportingIndexRoute
  '/scheduling/': typeof SchedulingIndexRoute
  '/ships/': typeof ShipsIndexRoute
  '/site-context-monitoring/': typeof SiteContextMonitoringIndexRoute
  '/system-lens/': typeof SystemLensIndexRoute
  '/users/': typeof UsersIndexRoute
  '/value-stories/': typeof ValueStoriesIndexRoute
  '/viewer-routing/': typeof ViewerRoutingIndexRoute
  '/viewer/': typeof ViewerIndexRoute
  '/virtual-reports/': typeof VirtualReportsIndexRoute
  '/walkdowns/': typeof WalkdownsIndexRoute
  '/walkthrough/': typeof WalkthroughIndexRoute
  '/weldmap/': typeof WeldmapIndexRoute
  '/site-view/$siteID': typeof deprecated_page_namesSiteViewSiteIDRoute
  '/alerts/$siteID': typeof Alertsdeprecated_routesSiteIDRoute
  '/anomaly-detection/$siteID': typeof AnomalyDetectiondeprecated_routesSiteIDRouteWithChildren
  '/assets/{-$siteID}': typeof Assetsdeprecated_routesChar123SiteIDChar125Route
  '/assets/lifecycle': typeof Assetssingle_asset_destinationsLifecycleRoute
  '/assets/unit': typeof Assetssingle_asset_destinationsUnitRoute
  '/availability-planning/$siteID': typeof AvailabilityPlanningdeprecated_routesSiteIDRouteWithChildren
  '/budgeting/$siteID': typeof Budgetingdeprecated_routesSiteIDRoute
  '/cases/$siteID': typeof Casesdeprecated_routesSiteIDRouteWithChildren
  '/extensions/$orgID': typeof Extensionsdeprecated_routesOrgIDRoute
  '/fleet-analysis/$siteID': typeof FleetAnalysisdeprecated_routesSiteIDRoute
  '/flightDataUpload/$siteID': typeof FlightDataUploaddeprecated_routesSiteIDRoute
  '/health-plans/$siteID': typeof HealthPlansdeprecated_routesSiteIDRoute
  '/home/{-$siteID}': typeof Homedeprecated_routesChar123SiteIDChar125Route
  '/inspections/$siteID': typeof Inspectionsdeprecated_routesSiteIDRoute
  '/job/$siteID': typeof Jobdeprecated_routesSiteIDRoute
  '/libra-dashboard/$orgID': typeof LibraDashboarddeprecated_routesOrgIDRouteWithChildren
  '/logbook/entry/$logEntryId': typeof LogbookEntryLogEntryIdRoute
  '/logbook/entry/new': typeof LogbookEntryNewRoute
  '/logbook/templates/$templateId': typeof LogbookTemplatesTemplateIdRoute
  '/logbook/templates/new': typeof LogbookTemplatesNewRoute
  '/maximo/$siteID': typeof Maximodeprecated_routesSiteIDRoute
  '/organization/$orgID': typeof Organizationdeprecated_routesOrgIDRoute
  '/overview/$siteID': typeof Overviewdeprecated_routesSiteIDRoute
  '/parts/$siteID': typeof Partsdeprecated_routesSiteIDRoute
  '/process-data/chart/$chartID': typeof ProcessDataChartChartIDRoute
  '/scheduling/$siteID': typeof Schedulingdeprecated_routesSiteIDRoute
  '/system-lens/$siteID': typeof SystemLensdeprecated_routesSiteIDRoute
  '/users/$orgID': typeof Usersdeprecated_routesOrgIDRoute
  '/viewer/$unitID/configuration': typeof ViewerUnitIDConfigurationRoute
  '/viewer/$unitID/inspection': typeof ViewerUnitIDInspectionRoute
  '/walkthrough/$siteID': typeof Walkthroughdeprecated_routesSiteIDRoute
  '/organization/site/': typeof OrganizationSiteIndexRoute
  '/viewer/$unitID/': typeof ViewerUnitIDIndexRoute
  '/anomaly-detection/$siteID/$detectionConfigurationId': typeof AnomalyDetectiondeprecated_routesSiteIDDetectionConfigurationIdRoute
  '/asset-assessment/$siteID/{-$unitID}': typeof AssetAssessmentdeprecated_routesSiteIDChar123UnitIDChar125Route
  '/asset-lens/$siteID/$unitID': typeof AssetLensdeprecated_routesSiteIDUnitIDRoute
  '/assets/$siteID/$unitID': typeof Assetsdeprecated_routesSiteIDUnitIDRoute
  '/availability-planning/$siteID/$shipID': typeof AvailabilityPlanningdeprecated_routesSiteIDShipIDRoute
  '/cases/$siteID/$caseID': typeof Casesdeprecated_routesSiteIDCaseIDRoute
  '/kestrel/forms/$inspectionType/$formName': typeof KestrelFormsInspectionTypeFormNameRoute
  '/libra-dashboard/$orgID/$dashboardConfigId': typeof LibraDashboarddeprecated_routesOrgIDDashboardConfigIdRoute
  '/libra/$orgID/{-$workflowId}': typeof Libradeprecated_routesOrgIDChar123WorkflowIdChar125Route
  '/organization/$orgID/site': typeof Organizationdeprecated_routesOrgIDSiteRouteWithChildren
  '/point-cloud/$siteID/{-$pointCloudOrSceneID}': typeof PointClouddeprecated_routesSiteIDChar123PointCloudOrSceneIDChar125Route
  '/prism/$orgID/$entryId': typeof Prismdeprecated_routesOrgIDEntryIdRoute
  '/process-data/$siteID/view': typeof ProcessDatadeprecated_routesSiteIDViewRoute
  '/process-flows/$siteID/$diagramID': typeof ProcessFlowsdeprecated_routesSiteIDDiagramIDRoute
  '/reporting/$siteID/$reportID': typeof Reportingdeprecated_routesSiteIDReportIDRoute
  '/reporting/$siteID/new': typeof Reportingdeprecated_routesSiteIDNewRoute
  '/value-stories/$siteID/add': typeof ValueStoriesdeprecated_routesSiteIDAddRoute
  '/virtual-reports/$siteID/$componentID': typeof VirtualReportsdeprecated_routesSiteIDComponentIDRoute
  '/walkdowns/$siteID/$walkdownId': typeof Walkdownsdeprecated_routesSiteIDWalkdownIdRoute
  '/process-data/$siteID/': typeof ProcessDatadeprecated_routesSiteIDIndexRoute
  '/process-flows/$siteID/': typeof ProcessFlowsdeprecated_routesSiteIDIndexRoute
  '/reporting/$siteID/': typeof Reportingdeprecated_routesSiteIDIndexRoute
  '/ships/$siteID/': typeof Shipsdeprecated_routesSiteIDIndexRoute
  '/value-stories/$siteID/': typeof ValueStoriesdeprecated_routesSiteIDIndexRoute
  '/virtual-reports/$siteID/': typeof VirtualReportsdeprecated_routesSiteIDIndexRoute
  '/walkdowns/$siteID/': typeof Walkdownsdeprecated_routesSiteIDIndexRoute
  '/cases/$siteID/edit/$caseID': typeof Casesdeprecated_routesSiteIDEditCaseIDRoute
  '/organization/$orgID/site/$siteID': typeof Organizationdeprecated_routesOrgIDSiteSiteIDRoute
  '/process-data/$siteID/chart/$chartID': typeof ProcessDatadeprecated_routesSiteIDChartChartIDRoute
  '/production-dashboard/$orgID/$siteID/$configID': typeof ProductionDashboarddeprecated_routesOrgIDSiteIDConfigIDRoute
  '/value-stories/$siteID/$valueStoryID/edit': typeof ValueStoriesdeprecated_routesSiteIDValueStoryIDEditRoute
  '/production-dashboard/$orgID/$siteID/': typeof ProductionDashboarddeprecated_routesOrgIDSiteIDIndexRoute
  '/value-stories/$siteID/$valueStoryID/': typeof ValueStoriesdeprecated_routesSiteIDValueStoryIDIndexRoute
}
export interface FileRoutesByTo {
  '/health-check': typeof HealthCheckRoute
  '/jobs': typeof JobsRoute
  '/landing': typeof LandingRoute
  '/okr-dashboard': typeof OkrDashboardRoute
  '/reconstruction': typeof ReconstructionRoute
  '/systemview': typeof SystemviewRouteWithChildren
  '/admin/access': typeof AdminAccessRoute
  '/admin/users': typeof AdminUsersRoute
  '/aerospace-gvi/$inspectionId': typeof AerospaceGviInspectionIdRoute
  '/alerts/details': typeof AlertsDetailsRoute
  '/anomaly-detection/config': typeof AnomalyDetectionConfigRoute
  '/assets/routing': typeof AssetsRoutingRoute
  '/cases/details': typeof CasesDetailsRoute
  '/cases/edit': typeof CasesEditRoute
  '/details/$entryID': typeof DetailsEntryIDRoute
  '/documents/upload': typeof DocumentsUploadRoute
  '/explorer/$orgOrSiteID': typeof ExplorerOrgOrSiteIDRoute
  '/fim/review': typeof FimReviewRoute
  '/forgings-indications/$inspectionId': typeof ForgingsIndicationsInspectionIdRoute
  '/inspection-dashboard/$orgOrSiteID': typeof InspectionDashboardOrgOrSiteIDRoute
  '/kestrel/$kestrelRolodexEntry': typeof KestrelKestrelRolodexEntryRoute
  '/point-cloud/view': typeof PointCloudViewRoute
  '/process-data/view': typeof ProcessDataViewRoute
  '/process-flows/diagram': typeof ProcessFlowsDiagramRoute
  '/production-dashboard/config': typeof ProductionDashboardConfigRoute
  '/reporting/details': typeof ReportingDetailsRoute
  '/reporting/new': typeof ReportingNewRoute
  '/systemview/$entryID': typeof SystemviewEntryIDRoute
  '/value-stories/add': typeof ValueStoriesAddRoute
  '/value-stories/details': typeof ValueStoriesDetailsRoute
  '/value-stories/edit': typeof ValueStoriesEditRoute
  '/virtual-reports/details': typeof VirtualReportsDetailsRoute
  '/walkdowns/details': typeof WalkdownsDetailsRoute
  '/weldmap/$kestrelModelId': typeof WeldmapKestrelModelIdRoute
  '/': typeof Fallback_routeIndexRoute
  '/aerospace-gvi': typeof AerospaceGviIndexRoute
  '/alerts': typeof AlertsIndexRoute
  '/anomaly-detection': typeof AnomalyDetectionIndexRoute
  '/app-config': typeof AppConfigIndexRoute
  '/asset-assessment': typeof AssetAssessmentIndexRoute
  '/asset-lens': typeof AssetLensIndexRoute
  '/assets': typeof AssetsIndexRoute
  '/availability-planning': typeof AvailabilityPlanningIndexRoute
  '/budgeting': typeof BudgetingIndexRoute
  '/cases': typeof CasesIndexRoute
  '/document-viewer': typeof DocumentViewerIndexRoute
  '/documents': typeof DocumentsIndexRoute
  '/dossiers': typeof DossiersIndexRoute
  '/entry-browser': typeof EntryBrowserIndexRoute
  '/explorer': typeof ExplorerIndexRoute
  '/extensions': typeof ExtensionsIndexRoute
  '/fim': typeof FimIndexRoute
  '/fleet-analysis': typeof FleetAnalysisIndexRoute
  '/flightDataUpload': typeof FlightDataUploadIndexRoute
  '/health-plans': typeof HealthPlansIndexRoute
  '/home': typeof HomeIndexRoute
  '/inspection-dashboard': typeof InspectionDashboardIndexRoute
  '/inspections': typeof InspectionsIndexRoute
  '/job': typeof JobIndexRoute
  '/kestrel': typeof KestrelIndexRoute
  '/libra-dashboard': typeof LibraDashboardIndexRoute
  '/libra': typeof LibraIndexRoute
  '/logbook': typeof LogbookIndexRoute
  '/maximo': typeof MaximoIndexRoute
  '/nii-dashboard': typeof NiiDashboardIndexRoute
  '/notifications': typeof NotificationsIndexRoute
  '/organization': typeof OrganizationIndexRoute
  '/overview': typeof OverviewIndexRoute
  '/parts': typeof PartsIndexRoute
  '/pipelines': typeof PipelinesIndexRoute
  '/point-cloud': typeof PointCloudIndexRoute
  '/prism': typeof PrismIndexRoute
  '/process-data': typeof ProcessDataIndexRoute
  '/process-flows': typeof ProcessFlowsIndexRoute
  '/production-dashboard': typeof ProductionDashboardIndexRoute
  '/reporting': typeof ReportingIndexRoute
  '/scheduling': typeof SchedulingIndexRoute
  '/ships': typeof ShipsIndexRoute
  '/site-context-monitoring': typeof SiteContextMonitoringIndexRoute
  '/system-lens': typeof SystemLensIndexRoute
  '/users': typeof UsersIndexRoute
  '/value-stories': typeof ValueStoriesIndexRoute
  '/viewer-routing': typeof ViewerRoutingIndexRoute
  '/viewer': typeof ViewerIndexRoute
  '/virtual-reports': typeof VirtualReportsIndexRoute
  '/walkdowns': typeof WalkdownsIndexRoute
  '/walkthrough': typeof WalkthroughIndexRoute
  '/weldmap': typeof WeldmapIndexRoute
  '/site-view/$siteID': typeof deprecated_page_namesSiteViewSiteIDRoute
  '/alerts/$siteID': typeof Alertsdeprecated_routesSiteIDRoute
  '/anomaly-detection/$siteID': typeof AnomalyDetectiondeprecated_routesSiteIDRouteWithChildren
  '/assets/{-$siteID}': typeof Assetsdeprecated_routesChar123SiteIDChar125Route
  '/assets/lifecycle': typeof Assetssingle_asset_destinationsLifecycleRoute
  '/assets/unit': typeof Assetssingle_asset_destinationsUnitRoute
  '/availability-planning/$siteID': typeof AvailabilityPlanningdeprecated_routesSiteIDRouteWithChildren
  '/budgeting/$siteID': typeof Budgetingdeprecated_routesSiteIDRoute
  '/cases/$siteID': typeof Casesdeprecated_routesSiteIDRouteWithChildren
  '/extensions/$orgID': typeof Extensionsdeprecated_routesOrgIDRoute
  '/fleet-analysis/$siteID': typeof FleetAnalysisdeprecated_routesSiteIDRoute
  '/flightDataUpload/$siteID': typeof FlightDataUploaddeprecated_routesSiteIDRoute
  '/health-plans/$siteID': typeof HealthPlansdeprecated_routesSiteIDRoute
  '/home/{-$siteID}': typeof Homedeprecated_routesChar123SiteIDChar125Route
  '/inspections/$siteID': typeof Inspectionsdeprecated_routesSiteIDRoute
  '/job/$siteID': typeof Jobdeprecated_routesSiteIDRoute
  '/libra-dashboard/$orgID': typeof LibraDashboarddeprecated_routesOrgIDRouteWithChildren
  '/logbook/entry/$logEntryId': typeof LogbookEntryLogEntryIdRoute
  '/logbook/entry/new': typeof LogbookEntryNewRoute
  '/logbook/templates/$templateId': typeof LogbookTemplatesTemplateIdRoute
  '/logbook/templates/new': typeof LogbookTemplatesNewRoute
  '/maximo/$siteID': typeof Maximodeprecated_routesSiteIDRoute
  '/organization/$orgID': typeof Organizationdeprecated_routesOrgIDRoute
  '/overview/$siteID': typeof Overviewdeprecated_routesSiteIDRoute
  '/parts/$siteID': typeof Partsdeprecated_routesSiteIDRoute
  '/process-data/chart/$chartID': typeof ProcessDataChartChartIDRoute
  '/scheduling/$siteID': typeof Schedulingdeprecated_routesSiteIDRoute
  '/system-lens/$siteID': typeof SystemLensdeprecated_routesSiteIDRoute
  '/users/$orgID': typeof Usersdeprecated_routesOrgIDRoute
  '/viewer/$unitID/configuration': typeof ViewerUnitIDConfigurationRoute
  '/viewer/$unitID/inspection': typeof ViewerUnitIDInspectionRoute
  '/walkthrough/$siteID': typeof Walkthroughdeprecated_routesSiteIDRoute
  '/organization/site': typeof OrganizationSiteIndexRoute
  '/viewer/$unitID': typeof ViewerUnitIDIndexRoute
  '/anomaly-detection/$siteID/$detectionConfigurationId': typeof AnomalyDetectiondeprecated_routesSiteIDDetectionConfigurationIdRoute
  '/asset-assessment/$siteID/{-$unitID}': typeof AssetAssessmentdeprecated_routesSiteIDChar123UnitIDChar125Route
  '/asset-lens/$siteID/$unitID': typeof AssetLensdeprecated_routesSiteIDUnitIDRoute
  '/assets/$siteID/$unitID': typeof Assetsdeprecated_routesSiteIDUnitIDRoute
  '/availability-planning/$siteID/$shipID': typeof AvailabilityPlanningdeprecated_routesSiteIDShipIDRoute
  '/cases/$siteID/$caseID': typeof Casesdeprecated_routesSiteIDCaseIDRoute
  '/kestrel/forms/$inspectionType/$formName': typeof KestrelFormsInspectionTypeFormNameRoute
  '/libra-dashboard/$orgID/$dashboardConfigId': typeof LibraDashboarddeprecated_routesOrgIDDashboardConfigIdRoute
  '/libra/$orgID/{-$workflowId}': typeof Libradeprecated_routesOrgIDChar123WorkflowIdChar125Route
  '/organization/$orgID/site': typeof Organizationdeprecated_routesOrgIDSiteRouteWithChildren
  '/point-cloud/$siteID/{-$pointCloudOrSceneID}': typeof PointClouddeprecated_routesSiteIDChar123PointCloudOrSceneIDChar125Route
  '/prism/$orgID/$entryId': typeof Prismdeprecated_routesOrgIDEntryIdRoute
  '/process-data/$siteID/view': typeof ProcessDatadeprecated_routesSiteIDViewRoute
  '/process-flows/$siteID/$diagramID': typeof ProcessFlowsdeprecated_routesSiteIDDiagramIDRoute
  '/reporting/$siteID/$reportID': typeof Reportingdeprecated_routesSiteIDReportIDRoute
  '/reporting/$siteID/new': typeof Reportingdeprecated_routesSiteIDNewRoute
  '/value-stories/$siteID/add': typeof ValueStoriesdeprecated_routesSiteIDAddRoute
  '/virtual-reports/$siteID/$componentID': typeof VirtualReportsdeprecated_routesSiteIDComponentIDRoute
  '/walkdowns/$siteID/$walkdownId': typeof Walkdownsdeprecated_routesSiteIDWalkdownIdRoute
  '/process-data/$siteID': typeof ProcessDatadeprecated_routesSiteIDIndexRoute
  '/process-flows/$siteID': typeof ProcessFlowsdeprecated_routesSiteIDIndexRoute
  '/reporting/$siteID': typeof Reportingdeprecated_routesSiteIDIndexRoute
  '/ships/$siteID': typeof Shipsdeprecated_routesSiteIDIndexRoute
  '/value-stories/$siteID': typeof ValueStoriesdeprecated_routesSiteIDIndexRoute
  '/virtual-reports/$siteID': typeof VirtualReportsdeprecated_routesSiteIDIndexRoute
  '/walkdowns/$siteID': typeof Walkdownsdeprecated_routesSiteIDIndexRoute
  '/cases/$siteID/edit/$caseID': typeof Casesdeprecated_routesSiteIDEditCaseIDRoute
  '/organization/$orgID/site/$siteID': typeof Organizationdeprecated_routesOrgIDSiteSiteIDRoute
  '/process-data/$siteID/chart/$chartID': typeof ProcessDatadeprecated_routesSiteIDChartChartIDRoute
  '/production-dashboard/$orgID/$siteID/$configID': typeof ProductionDashboarddeprecated_routesOrgIDSiteIDConfigIDRoute
  '/value-stories/$siteID/$valueStoryID/edit': typeof ValueStoriesdeprecated_routesSiteIDValueStoryIDEditRoute
  '/production-dashboard/$orgID/$siteID': typeof ProductionDashboarddeprecated_routesOrgIDSiteIDIndexRoute
  '/value-stories/$siteID/$valueStoryID': typeof ValueStoriesdeprecated_routesSiteIDValueStoryIDIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/availability-planning': typeof AvailabilityPlanningRouteRouteWithChildren
  '/explorer': typeof ExplorerRouteRouteWithChildren
  '/inspection-dashboard': typeof InspectionDashboardRouteRouteWithChildren
  '/point-cloud': typeof PointCloudRouteRouteWithChildren
  '/aerospace-gvi': typeof AerospaceGviRouteWithChildren
  '/health-check': typeof HealthCheckRoute
  '/jobs': typeof JobsRoute
  '/kestrel': typeof KestrelRouteWithChildren
  '/landing': typeof LandingRoute
  '/okr-dashboard': typeof OkrDashboardRoute
  '/reconstruction': typeof ReconstructionRoute
  '/systemview': typeof SystemviewRouteWithChildren
  '/admin/access': typeof AdminAccessRoute
  '/admin/users': typeof AdminUsersRoute
  '/aerospace-gvi/$inspectionId': typeof AerospaceGviInspectionIdRoute
  '/alerts/details': typeof AlertsDetailsRoute
  '/anomaly-detection/config': typeof AnomalyDetectionConfigRoute
  '/assets/routing': typeof AssetsRoutingRoute
  '/cases/details': typeof CasesDetailsRoute
  '/cases/edit': typeof CasesEditRoute
  '/details/$entryID': typeof DetailsEntryIDRoute
  '/documents/upload': typeof DocumentsUploadRoute
  '/explorer/$orgOrSiteID': typeof ExplorerOrgOrSiteIDRoute
  '/fim/review': typeof FimReviewRoute
  '/forgings-indications/$inspectionId': typeof ForgingsIndicationsInspectionIdRoute
  '/inspection-dashboard/$orgOrSiteID': typeof InspectionDashboardOrgOrSiteIDRoute
  '/kestrel/$kestrelRolodexEntry': typeof KestrelKestrelRolodexEntryRoute
  '/point-cloud/view': typeof PointCloudViewRoute
  '/process-data/view': typeof ProcessDataViewRoute
  '/process-flows/diagram': typeof ProcessFlowsDiagramRoute
  '/production-dashboard/config': typeof ProductionDashboardConfigRoute
  '/reporting/details': typeof ReportingDetailsRoute
  '/reporting/new': typeof ReportingNewRoute
  '/systemview/$entryID': typeof SystemviewEntryIDRoute
  '/value-stories/add': typeof ValueStoriesAddRoute
  '/value-stories/details': typeof ValueStoriesDetailsRoute
  '/value-stories/edit': typeof ValueStoriesEditRoute
  '/virtual-reports/details': typeof VirtualReportsDetailsRoute
  '/walkdowns/details': typeof WalkdownsDetailsRoute
  '/weldmap/$kestrelModelId': typeof WeldmapKestrelModelIdRoute
  '/_fallback_route/': typeof Fallback_routeIndexRoute
  '/aerospace-gvi/': typeof AerospaceGviIndexRoute
  '/alerts/': typeof AlertsIndexRoute
  '/anomaly-detection/': typeof AnomalyDetectionIndexRoute
  '/app-config/': typeof AppConfigIndexRoute
  '/asset-assessment/': typeof AssetAssessmentIndexRoute
  '/asset-lens/': typeof AssetLensIndexRoute
  '/assets/': typeof AssetsIndexRoute
  '/availability-planning/': typeof AvailabilityPlanningIndexRoute
  '/budgeting/': typeof BudgetingIndexRoute
  '/cases/': typeof CasesIndexRoute
  '/document-viewer/': typeof DocumentViewerIndexRoute
  '/documents/': typeof DocumentsIndexRoute
  '/dossiers/': typeof DossiersIndexRoute
  '/entry-browser/': typeof EntryBrowserIndexRoute
  '/explorer/': typeof ExplorerIndexRoute
  '/extensions/': typeof ExtensionsIndexRoute
  '/fim/': typeof FimIndexRoute
  '/fleet-analysis/': typeof FleetAnalysisIndexRoute
  '/flightDataUpload/': typeof FlightDataUploadIndexRoute
  '/health-plans/': typeof HealthPlansIndexRoute
  '/home/': typeof HomeIndexRoute
  '/inspection-dashboard/': typeof InspectionDashboardIndexRoute
  '/inspections/': typeof InspectionsIndexRoute
  '/job/': typeof JobIndexRoute
  '/kestrel/': typeof KestrelIndexRoute
  '/libra-dashboard/': typeof LibraDashboardIndexRoute
  '/libra/': typeof LibraIndexRoute
  '/logbook/': typeof LogbookIndexRoute
  '/maximo/': typeof MaximoIndexRoute
  '/nii-dashboard/': typeof NiiDashboardIndexRoute
  '/notifications/': typeof NotificationsIndexRoute
  '/organization/': typeof OrganizationIndexRoute
  '/overview/': typeof OverviewIndexRoute
  '/parts/': typeof PartsIndexRoute
  '/pipelines/': typeof PipelinesIndexRoute
  '/point-cloud/': typeof PointCloudIndexRoute
  '/prism/': typeof PrismIndexRoute
  '/process-data/': typeof ProcessDataIndexRoute
  '/process-flows/': typeof ProcessFlowsIndexRoute
  '/production-dashboard/': typeof ProductionDashboardIndexRoute
  '/reporting/': typeof ReportingIndexRoute
  '/scheduling/': typeof SchedulingIndexRoute
  '/ships/': typeof ShipsIndexRoute
  '/site-context-monitoring/': typeof SiteContextMonitoringIndexRoute
  '/system-lens/': typeof SystemLensIndexRoute
  '/users/': typeof UsersIndexRoute
  '/value-stories/': typeof ValueStoriesIndexRoute
  '/viewer-routing/': typeof ViewerRoutingIndexRoute
  '/viewer/': typeof ViewerIndexRoute
  '/virtual-reports/': typeof VirtualReportsIndexRoute
  '/walkdowns/': typeof WalkdownsIndexRoute
  '/walkthrough/': typeof WalkthroughIndexRoute
  '/weldmap/': typeof WeldmapIndexRoute
  '/(deprecated_page_names)/site-view/$siteID': typeof deprecated_page_namesSiteViewSiteIDRoute
  '/alerts/(deprecated_routes)/$siteID': typeof Alertsdeprecated_routesSiteIDRoute
  '/anomaly-detection/(deprecated_routes)/$siteID': typeof AnomalyDetectiondeprecated_routesSiteIDRouteWithChildren
  '/assets/(deprecated_routes)/{-$siteID}': typeof Assetsdeprecated_routesChar123SiteIDChar125Route
  '/assets/(single_asset_destinations)/lifecycle': typeof Assetssingle_asset_destinationsLifecycleRoute
  '/assets/(single_asset_destinations)/unit': typeof Assetssingle_asset_destinationsUnitRoute
  '/availability-planning/(deprecated_routes)/$siteID': typeof AvailabilityPlanningdeprecated_routesSiteIDRouteWithChildren
  '/budgeting/(deprecated_routes)/$siteID': typeof Budgetingdeprecated_routesSiteIDRoute
  '/cases/(deprecated_routes)/$siteID': typeof Casesdeprecated_routesSiteIDRouteWithChildren
  '/extensions/(deprecated_routes)/$orgID': typeof Extensionsdeprecated_routesOrgIDRoute
  '/fleet-analysis/(deprecated_routes)/$siteID': typeof FleetAnalysisdeprecated_routesSiteIDRoute
  '/flightDataUpload/(deprecated_routes)/$siteID': typeof FlightDataUploaddeprecated_routesSiteIDRoute
  '/health-plans/(deprecated_routes)/$siteID': typeof HealthPlansdeprecated_routesSiteIDRoute
  '/home/(deprecated_routes)/{-$siteID}': typeof Homedeprecated_routesChar123SiteIDChar125Route
  '/inspections/(deprecated_routes)/$siteID': typeof Inspectionsdeprecated_routesSiteIDRoute
  '/job/(deprecated_routes)/$siteID': typeof Jobdeprecated_routesSiteIDRoute
  '/libra-dashboard/(deprecated_routes)/$orgID': typeof LibraDashboarddeprecated_routesOrgIDRouteWithChildren
  '/logbook/entry/$logEntryId': typeof LogbookEntryLogEntryIdRoute
  '/logbook/entry/new': typeof LogbookEntryNewRoute
  '/logbook/templates/$templateId': typeof LogbookTemplatesTemplateIdRoute
  '/logbook/templates/new': typeof LogbookTemplatesNewRoute
  '/maximo/(deprecated_routes)/$siteID': typeof Maximodeprecated_routesSiteIDRoute
  '/organization/(deprecated_routes)/$orgID': typeof Organizationdeprecated_routesOrgIDRoute
  '/overview/(deprecated_routes)/$siteID': typeof Overviewdeprecated_routesSiteIDRoute
  '/parts/(deprecated_routes)/$siteID': typeof Partsdeprecated_routesSiteIDRoute
  '/process-data/chart/$chartID': typeof ProcessDataChartChartIDRoute
  '/scheduling/(deprecated_routes)/$siteID': typeof Schedulingdeprecated_routesSiteIDRoute
  '/system-lens/(deprecated_routes)/$siteID': typeof SystemLensdeprecated_routesSiteIDRoute
  '/users/(deprecated_routes)/$orgID': typeof Usersdeprecated_routesOrgIDRoute
  '/viewer/$unitID/configuration': typeof ViewerUnitIDConfigurationRoute
  '/viewer/$unitID/inspection': typeof ViewerUnitIDInspectionRoute
  '/walkthrough/(deprecated_routes)/$siteID': typeof Walkthroughdeprecated_routesSiteIDRoute
  '/organization_/site/': typeof OrganizationSiteIndexRoute
  '/viewer/$unitID/': typeof ViewerUnitIDIndexRoute
  '/anomaly-detection/(deprecated_routes)/$siteID/$detectionConfigurationId': typeof AnomalyDetectiondeprecated_routesSiteIDDetectionConfigurationIdRoute
  '/asset-assessment/(deprecated_routes)/$siteID/{-$unitID}': typeof AssetAssessmentdeprecated_routesSiteIDChar123UnitIDChar125Route
  '/asset-lens/(deprecated_routes)/$siteID/$unitID': typeof AssetLensdeprecated_routesSiteIDUnitIDRoute
  '/assets/(deprecated_routes)/$siteID/$unitID': typeof Assetsdeprecated_routesSiteIDUnitIDRoute
  '/availability-planning/(deprecated_routes)/$siteID/$shipID': typeof AvailabilityPlanningdeprecated_routesSiteIDShipIDRoute
  '/cases/(deprecated_routes)/$siteID/$caseID': typeof Casesdeprecated_routesSiteIDCaseIDRoute
  '/kestrel/forms/$inspectionType/$formName': typeof KestrelFormsInspectionTypeFormNameRoute
  '/libra-dashboard/(deprecated_routes)/$orgID/$dashboardConfigId': typeof LibraDashboarddeprecated_routesOrgIDDashboardConfigIdRoute
  '/libra/(deprecated_routes)/$orgID/{-$workflowId}': typeof Libradeprecated_routesOrgIDChar123WorkflowIdChar125Route
  '/organization_/(deprecated_routes)/$orgID/site': typeof Organizationdeprecated_routesOrgIDSiteRouteWithChildren
  '/point-cloud/(deprecated_routes)/$siteID/{-$pointCloudOrSceneID}': typeof PointClouddeprecated_routesSiteIDChar123PointCloudOrSceneIDChar125Route
  '/prism/(deprecated_routes)/$orgID/$entryId': typeof Prismdeprecated_routesOrgIDEntryIdRoute
  '/process-data/(deprecated_routes)/$siteID/view': typeof ProcessDatadeprecated_routesSiteIDViewRoute
  '/process-flows/(deprecated_routes)/$siteID/$diagramID': typeof ProcessFlowsdeprecated_routesSiteIDDiagramIDRoute
  '/reporting/(deprecated_routes)/$siteID/$reportID': typeof Reportingdeprecated_routesSiteIDReportIDRoute
  '/reporting/(deprecated_routes)/$siteID/new': typeof Reportingdeprecated_routesSiteIDNewRoute
  '/value-stories/(deprecated_routes)/$siteID/add': typeof ValueStoriesdeprecated_routesSiteIDAddRoute
  '/virtual-reports/(deprecated_routes)/$siteID/$componentID': typeof VirtualReportsdeprecated_routesSiteIDComponentIDRoute
  '/walkdowns/(deprecated_routes)/$siteID/$walkdownId': typeof Walkdownsdeprecated_routesSiteIDWalkdownIdRoute
  '/process-data/(deprecated_routes)/$siteID/': typeof ProcessDatadeprecated_routesSiteIDIndexRoute
  '/process-flows/(deprecated_routes)/$siteID/': typeof ProcessFlowsdeprecated_routesSiteIDIndexRoute
  '/reporting/(deprecated_routes)/$siteID/': typeof Reportingdeprecated_routesSiteIDIndexRoute
  '/ships/(deprecated_routes)/$siteID/': typeof Shipsdeprecated_routesSiteIDIndexRoute
  '/value-stories/(deprecated_routes)/$siteID/': typeof ValueStoriesdeprecated_routesSiteIDIndexRoute
  '/virtual-reports/(deprecated_routes)/$siteID/': typeof VirtualReportsdeprecated_routesSiteIDIndexRoute
  '/walkdowns/(deprecated_routes)/$siteID/': typeof Walkdownsdeprecated_routesSiteIDIndexRoute
  '/cases/(deprecated_routes)/$siteID/edit/$caseID': typeof Casesdeprecated_routesSiteIDEditCaseIDRoute
  '/organization_/(deprecated_routes)/$orgID/site/$siteID': typeof Organizationdeprecated_routesOrgIDSiteSiteIDRoute
  '/process-data/(deprecated_routes)/$siteID/chart/$chartID': typeof ProcessDatadeprecated_routesSiteIDChartChartIDRoute
  '/production-dashboard/(deprecated_routes)/$orgID/$siteID/$configID': typeof ProductionDashboarddeprecated_routesOrgIDSiteIDConfigIDRoute
  '/value-stories/(deprecated_routes)/$siteID/$valueStoryID/edit': typeof ValueStoriesdeprecated_routesSiteIDValueStoryIDEditRoute
  '/production-dashboard/(deprecated_routes)/$orgID/$siteID/': typeof ProductionDashboarddeprecated_routesOrgIDSiteIDIndexRoute
  '/value-stories/(deprecated_routes)/$siteID/$valueStoryID/': typeof ValueStoriesdeprecated_routesSiteIDValueStoryIDIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/availability-planning'
    | '/explorer'
    | '/inspection-dashboard'
    | '/point-cloud'
    | '/aerospace-gvi'
    | '/health-check'
    | '/jobs'
    | '/kestrel'
    | '/landing'
    | '/okr-dashboard'
    | '/reconstruction'
    | '/systemview'
    | '/admin/access'
    | '/admin/users'
    | '/aerospace-gvi/$inspectionId'
    | '/alerts/details'
    | '/anomaly-detection/config'
    | '/assets/routing'
    | '/cases/details'
    | '/cases/edit'
    | '/details/$entryID'
    | '/documents/upload'
    | '/explorer/$orgOrSiteID'
    | '/fim/review'
    | '/forgings-indications/$inspectionId'
    | '/inspection-dashboard/$orgOrSiteID'
    | '/kestrel/$kestrelRolodexEntry'
    | '/point-cloud/view'
    | '/process-data/view'
    | '/process-flows/diagram'
    | '/production-dashboard/config'
    | '/reporting/details'
    | '/reporting/new'
    | '/systemview/$entryID'
    | '/value-stories/add'
    | '/value-stories/details'
    | '/value-stories/edit'
    | '/virtual-reports/details'
    | '/walkdowns/details'
    | '/weldmap/$kestrelModelId'
    | '/'
    | '/aerospace-gvi/'
    | '/alerts/'
    | '/anomaly-detection/'
    | '/app-config/'
    | '/asset-assessment/'
    | '/asset-lens/'
    | '/assets/'
    | '/availability-planning/'
    | '/budgeting/'
    | '/cases/'
    | '/document-viewer/'
    | '/documents/'
    | '/dossiers/'
    | '/entry-browser/'
    | '/explorer/'
    | '/extensions/'
    | '/fim/'
    | '/fleet-analysis/'
    | '/flightDataUpload/'
    | '/health-plans/'
    | '/home/'
    | '/inspection-dashboard/'
    | '/inspections/'
    | '/job/'
    | '/kestrel/'
    | '/libra-dashboard/'
    | '/libra/'
    | '/logbook/'
    | '/maximo/'
    | '/nii-dashboard/'
    | '/notifications/'
    | '/organization/'
    | '/overview/'
    | '/parts/'
    | '/pipelines/'
    | '/point-cloud/'
    | '/prism/'
    | '/process-data/'
    | '/process-flows/'
    | '/production-dashboard/'
    | '/reporting/'
    | '/scheduling/'
    | '/ships/'
    | '/site-context-monitoring/'
    | '/system-lens/'
    | '/users/'
    | '/value-stories/'
    | '/viewer-routing/'
    | '/viewer/'
    | '/virtual-reports/'
    | '/walkdowns/'
    | '/walkthrough/'
    | '/weldmap/'
    | '/site-view/$siteID'
    | '/alerts/$siteID'
    | '/anomaly-detection/$siteID'
    | '/assets/{-$siteID}'
    | '/assets/lifecycle'
    | '/assets/unit'
    | '/availability-planning/$siteID'
    | '/budgeting/$siteID'
    | '/cases/$siteID'
    | '/extensions/$orgID'
    | '/fleet-analysis/$siteID'
    | '/flightDataUpload/$siteID'
    | '/health-plans/$siteID'
    | '/home/{-$siteID}'
    | '/inspections/$siteID'
    | '/job/$siteID'
    | '/libra-dashboard/$orgID'
    | '/logbook/entry/$logEntryId'
    | '/logbook/entry/new'
    | '/logbook/templates/$templateId'
    | '/logbook/templates/new'
    | '/maximo/$siteID'
    | '/organization/$orgID'
    | '/overview/$siteID'
    | '/parts/$siteID'
    | '/process-data/chart/$chartID'
    | '/scheduling/$siteID'
    | '/system-lens/$siteID'
    | '/users/$orgID'
    | '/viewer/$unitID/configuration'
    | '/viewer/$unitID/inspection'
    | '/walkthrough/$siteID'
    | '/organization/site/'
    | '/viewer/$unitID/'
    | '/anomaly-detection/$siteID/$detectionConfigurationId'
    | '/asset-assessment/$siteID/{-$unitID}'
    | '/asset-lens/$siteID/$unitID'
    | '/assets/$siteID/$unitID'
    | '/availability-planning/$siteID/$shipID'
    | '/cases/$siteID/$caseID'
    | '/kestrel/forms/$inspectionType/$formName'
    | '/libra-dashboard/$orgID/$dashboardConfigId'
    | '/libra/$orgID/{-$workflowId}'
    | '/organization/$orgID/site'
    | '/point-cloud/$siteID/{-$pointCloudOrSceneID}'
    | '/prism/$orgID/$entryId'
    | '/process-data/$siteID/view'
    | '/process-flows/$siteID/$diagramID'
    | '/reporting/$siteID/$reportID'
    | '/reporting/$siteID/new'
    | '/value-stories/$siteID/add'
    | '/virtual-reports/$siteID/$componentID'
    | '/walkdowns/$siteID/$walkdownId'
    | '/process-data/$siteID/'
    | '/process-flows/$siteID/'
    | '/reporting/$siteID/'
    | '/ships/$siteID/'
    | '/value-stories/$siteID/'
    | '/virtual-reports/$siteID/'
    | '/walkdowns/$siteID/'
    | '/cases/$siteID/edit/$caseID'
    | '/organization/$orgID/site/$siteID'
    | '/process-data/$siteID/chart/$chartID'
    | '/production-dashboard/$orgID/$siteID/$configID'
    | '/value-stories/$siteID/$valueStoryID/edit'
    | '/production-dashboard/$orgID/$siteID/'
    | '/value-stories/$siteID/$valueStoryID/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/health-check'
    | '/jobs'
    | '/landing'
    | '/okr-dashboard'
    | '/reconstruction'
    | '/systemview'
    | '/admin/access'
    | '/admin/users'
    | '/aerospace-gvi/$inspectionId'
    | '/alerts/details'
    | '/anomaly-detection/config'
    | '/assets/routing'
    | '/cases/details'
    | '/cases/edit'
    | '/details/$entryID'
    | '/documents/upload'
    | '/explorer/$orgOrSiteID'
    | '/fim/review'
    | '/forgings-indications/$inspectionId'
    | '/inspection-dashboard/$orgOrSiteID'
    | '/kestrel/$kestrelRolodexEntry'
    | '/point-cloud/view'
    | '/process-data/view'
    | '/process-flows/diagram'
    | '/production-dashboard/config'
    | '/reporting/details'
    | '/reporting/new'
    | '/systemview/$entryID'
    | '/value-stories/add'
    | '/value-stories/details'
    | '/value-stories/edit'
    | '/virtual-reports/details'
    | '/walkdowns/details'
    | '/weldmap/$kestrelModelId'
    | '/'
    | '/aerospace-gvi'
    | '/alerts'
    | '/anomaly-detection'
    | '/app-config'
    | '/asset-assessment'
    | '/asset-lens'
    | '/assets'
    | '/availability-planning'
    | '/budgeting'
    | '/cases'
    | '/document-viewer'
    | '/documents'
    | '/dossiers'
    | '/entry-browser'
    | '/explorer'
    | '/extensions'
    | '/fim'
    | '/fleet-analysis'
    | '/flightDataUpload'
    | '/health-plans'
    | '/home'
    | '/inspection-dashboard'
    | '/inspections'
    | '/job'
    | '/kestrel'
    | '/libra-dashboard'
    | '/libra'
    | '/logbook'
    | '/maximo'
    | '/nii-dashboard'
    | '/notifications'
    | '/organization'
    | '/overview'
    | '/parts'
    | '/pipelines'
    | '/point-cloud'
    | '/prism'
    | '/process-data'
    | '/process-flows'
    | '/production-dashboard'
    | '/reporting'
    | '/scheduling'
    | '/ships'
    | '/site-context-monitoring'
    | '/system-lens'
    | '/users'
    | '/value-stories'
    | '/viewer-routing'
    | '/viewer'
    | '/virtual-reports'
    | '/walkdowns'
    | '/walkthrough'
    | '/weldmap'
    | '/site-view/$siteID'
    | '/alerts/$siteID'
    | '/anomaly-detection/$siteID'
    | '/assets/{-$siteID}'
    | '/assets/lifecycle'
    | '/assets/unit'
    | '/availability-planning/$siteID'
    | '/budgeting/$siteID'
    | '/cases/$siteID'
    | '/extensions/$orgID'
    | '/fleet-analysis/$siteID'
    | '/flightDataUpload/$siteID'
    | '/health-plans/$siteID'
    | '/home/{-$siteID}'
    | '/inspections/$siteID'
    | '/job/$siteID'
    | '/libra-dashboard/$orgID'
    | '/logbook/entry/$logEntryId'
    | '/logbook/entry/new'
    | '/logbook/templates/$templateId'
    | '/logbook/templates/new'
    | '/maximo/$siteID'
    | '/organization/$orgID'
    | '/overview/$siteID'
    | '/parts/$siteID'
    | '/process-data/chart/$chartID'
    | '/scheduling/$siteID'
    | '/system-lens/$siteID'
    | '/users/$orgID'
    | '/viewer/$unitID/configuration'
    | '/viewer/$unitID/inspection'
    | '/walkthrough/$siteID'
    | '/organization/site'
    | '/viewer/$unitID'
    | '/anomaly-detection/$siteID/$detectionConfigurationId'
    | '/asset-assessment/$siteID/{-$unitID}'
    | '/asset-lens/$siteID/$unitID'
    | '/assets/$siteID/$unitID'
    | '/availability-planning/$siteID/$shipID'
    | '/cases/$siteID/$caseID'
    | '/kestrel/forms/$inspectionType/$formName'
    | '/libra-dashboard/$orgID/$dashboardConfigId'
    | '/libra/$orgID/{-$workflowId}'
    | '/organization/$orgID/site'
    | '/point-cloud/$siteID/{-$pointCloudOrSceneID}'
    | '/prism/$orgID/$entryId'
    | '/process-data/$siteID/view'
    | '/process-flows/$siteID/$diagramID'
    | '/reporting/$siteID/$reportID'
    | '/reporting/$siteID/new'
    | '/value-stories/$siteID/add'
    | '/virtual-reports/$siteID/$componentID'
    | '/walkdowns/$siteID/$walkdownId'
    | '/process-data/$siteID'
    | '/process-flows/$siteID'
    | '/reporting/$siteID'
    | '/ships/$siteID'
    | '/value-stories/$siteID'
    | '/virtual-reports/$siteID'
    | '/walkdowns/$siteID'
    | '/cases/$siteID/edit/$caseID'
    | '/organization/$orgID/site/$siteID'
    | '/process-data/$siteID/chart/$chartID'
    | '/production-dashboard/$orgID/$siteID/$configID'
    | '/value-stories/$siteID/$valueStoryID/edit'
    | '/production-dashboard/$orgID/$siteID'
    | '/value-stories/$siteID/$valueStoryID'
  id:
    | '__root__'
    | '/availability-planning'
    | '/explorer'
    | '/inspection-dashboard'
    | '/point-cloud'
    | '/aerospace-gvi'
    | '/health-check'
    | '/jobs'
    | '/kestrel'
    | '/landing'
    | '/okr-dashboard'
    | '/reconstruction'
    | '/systemview'
    | '/admin/access'
    | '/admin/users'
    | '/aerospace-gvi/$inspectionId'
    | '/alerts/details'
    | '/anomaly-detection/config'
    | '/assets/routing'
    | '/cases/details'
    | '/cases/edit'
    | '/details/$entryID'
    | '/documents/upload'
    | '/explorer/$orgOrSiteID'
    | '/fim/review'
    | '/forgings-indications/$inspectionId'
    | '/inspection-dashboard/$orgOrSiteID'
    | '/kestrel/$kestrelRolodexEntry'
    | '/point-cloud/view'
    | '/process-data/view'
    | '/process-flows/diagram'
    | '/production-dashboard/config'
    | '/reporting/details'
    | '/reporting/new'
    | '/systemview/$entryID'
    | '/value-stories/add'
    | '/value-stories/details'
    | '/value-stories/edit'
    | '/virtual-reports/details'
    | '/walkdowns/details'
    | '/weldmap/$kestrelModelId'
    | '/_fallback_route/'
    | '/aerospace-gvi/'
    | '/alerts/'
    | '/anomaly-detection/'
    | '/app-config/'
    | '/asset-assessment/'
    | '/asset-lens/'
    | '/assets/'
    | '/availability-planning/'
    | '/budgeting/'
    | '/cases/'
    | '/document-viewer/'
    | '/documents/'
    | '/dossiers/'
    | '/entry-browser/'
    | '/explorer/'
    | '/extensions/'
    | '/fim/'
    | '/fleet-analysis/'
    | '/flightDataUpload/'
    | '/health-plans/'
    | '/home/'
    | '/inspection-dashboard/'
    | '/inspections/'
    | '/job/'
    | '/kestrel/'
    | '/libra-dashboard/'
    | '/libra/'
    | '/logbook/'
    | '/maximo/'
    | '/nii-dashboard/'
    | '/notifications/'
    | '/organization/'
    | '/overview/'
    | '/parts/'
    | '/pipelines/'
    | '/point-cloud/'
    | '/prism/'
    | '/process-data/'
    | '/process-flows/'
    | '/production-dashboard/'
    | '/reporting/'
    | '/scheduling/'
    | '/ships/'
    | '/site-context-monitoring/'
    | '/system-lens/'
    | '/users/'
    | '/value-stories/'
    | '/viewer-routing/'
    | '/viewer/'
    | '/virtual-reports/'
    | '/walkdowns/'
    | '/walkthrough/'
    | '/weldmap/'
    | '/(deprecated_page_names)/site-view/$siteID'
    | '/alerts/(deprecated_routes)/$siteID'
    | '/anomaly-detection/(deprecated_routes)/$siteID'
    | '/assets/(deprecated_routes)/{-$siteID}'
    | '/assets/(single_asset_destinations)/lifecycle'
    | '/assets/(single_asset_destinations)/unit'
    | '/availability-planning/(deprecated_routes)/$siteID'
    | '/budgeting/(deprecated_routes)/$siteID'
    | '/cases/(deprecated_routes)/$siteID'
    | '/extensions/(deprecated_routes)/$orgID'
    | '/fleet-analysis/(deprecated_routes)/$siteID'
    | '/flightDataUpload/(deprecated_routes)/$siteID'
    | '/health-plans/(deprecated_routes)/$siteID'
    | '/home/(deprecated_routes)/{-$siteID}'
    | '/inspections/(deprecated_routes)/$siteID'
    | '/job/(deprecated_routes)/$siteID'
    | '/libra-dashboard/(deprecated_routes)/$orgID'
    | '/logbook/entry/$logEntryId'
    | '/logbook/entry/new'
    | '/logbook/templates/$templateId'
    | '/logbook/templates/new'
    | '/maximo/(deprecated_routes)/$siteID'
    | '/organization/(deprecated_routes)/$orgID'
    | '/overview/(deprecated_routes)/$siteID'
    | '/parts/(deprecated_routes)/$siteID'
    | '/process-data/chart/$chartID'
    | '/scheduling/(deprecated_routes)/$siteID'
    | '/system-lens/(deprecated_routes)/$siteID'
    | '/users/(deprecated_routes)/$orgID'
    | '/viewer/$unitID/configuration'
    | '/viewer/$unitID/inspection'
    | '/walkthrough/(deprecated_routes)/$siteID'
    | '/organization_/site/'
    | '/viewer/$unitID/'
    | '/anomaly-detection/(deprecated_routes)/$siteID/$detectionConfigurationId'
    | '/asset-assessment/(deprecated_routes)/$siteID/{-$unitID}'
    | '/asset-lens/(deprecated_routes)/$siteID/$unitID'
    | '/assets/(deprecated_routes)/$siteID/$unitID'
    | '/availability-planning/(deprecated_routes)/$siteID/$shipID'
    | '/cases/(deprecated_routes)/$siteID/$caseID'
    | '/kestrel/forms/$inspectionType/$formName'
    | '/libra-dashboard/(deprecated_routes)/$orgID/$dashboardConfigId'
    | '/libra/(deprecated_routes)/$orgID/{-$workflowId}'
    | '/organization_/(deprecated_routes)/$orgID/site'
    | '/point-cloud/(deprecated_routes)/$siteID/{-$pointCloudOrSceneID}'
    | '/prism/(deprecated_routes)/$orgID/$entryId'
    | '/process-data/(deprecated_routes)/$siteID/view'
    | '/process-flows/(deprecated_routes)/$siteID/$diagramID'
    | '/reporting/(deprecated_routes)/$siteID/$reportID'
    | '/reporting/(deprecated_routes)/$siteID/new'
    | '/value-stories/(deprecated_routes)/$siteID/add'
    | '/virtual-reports/(deprecated_routes)/$siteID/$componentID'
    | '/walkdowns/(deprecated_routes)/$siteID/$walkdownId'
    | '/process-data/(deprecated_routes)/$siteID/'
    | '/process-flows/(deprecated_routes)/$siteID/'
    | '/reporting/(deprecated_routes)/$siteID/'
    | '/ships/(deprecated_routes)/$siteID/'
    | '/value-stories/(deprecated_routes)/$siteID/'
    | '/virtual-reports/(deprecated_routes)/$siteID/'
    | '/walkdowns/(deprecated_routes)/$siteID/'
    | '/cases/(deprecated_routes)/$siteID/edit/$caseID'
    | '/organization_/(deprecated_routes)/$orgID/site/$siteID'
    | '/process-data/(deprecated_routes)/$siteID/chart/$chartID'
    | '/production-dashboard/(deprecated_routes)/$orgID/$siteID/$configID'
    | '/value-stories/(deprecated_routes)/$siteID/$valueStoryID/edit'
    | '/production-dashboard/(deprecated_routes)/$orgID/$siteID/'
    | '/value-stories/(deprecated_routes)/$siteID/$valueStoryID/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AvailabilityPlanningRouteRoute: typeof AvailabilityPlanningRouteRouteWithChildren
  ExplorerRouteRoute: typeof ExplorerRouteRouteWithChildren
  InspectionDashboardRouteRoute: typeof InspectionDashboardRouteRouteWithChildren
  PointCloudRouteRoute: typeof PointCloudRouteRouteWithChildren
  AerospaceGviRoute: typeof AerospaceGviRouteWithChildren
  HealthCheckRoute: typeof HealthCheckRoute
  JobsRoute: typeof JobsRoute
  KestrelRoute: typeof KestrelRouteWithChildren
  LandingRoute: typeof LandingRoute
  OkrDashboardRoute: typeof OkrDashboardRoute
  ReconstructionRoute: typeof ReconstructionRoute
  SystemviewRoute: typeof SystemviewRouteWithChildren
  AdminAccessRoute: typeof AdminAccessRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AlertsDetailsRoute: typeof AlertsDetailsRoute
  AnomalyDetectionConfigRoute: typeof AnomalyDetectionConfigRoute
  AssetsRoutingRoute: typeof AssetsRoutingRoute
  CasesDetailsRoute: typeof CasesDetailsRoute
  CasesEditRoute: typeof CasesEditRoute
  DetailsEntryIDRoute: typeof DetailsEntryIDRoute
  DocumentsUploadRoute: typeof DocumentsUploadRoute
  FimReviewRoute: typeof FimReviewRoute
  ForgingsIndicationsInspectionIdRoute: typeof ForgingsIndicationsInspectionIdRoute
  ProcessDataViewRoute: typeof ProcessDataViewRoute
  ProcessFlowsDiagramRoute: typeof ProcessFlowsDiagramRoute
  ProductionDashboardConfigRoute: typeof ProductionDashboardConfigRoute
  ReportingDetailsRoute: typeof ReportingDetailsRoute
  ReportingNewRoute: typeof ReportingNewRoute
  ValueStoriesAddRoute: typeof ValueStoriesAddRoute
  ValueStoriesDetailsRoute: typeof ValueStoriesDetailsRoute
  ValueStoriesEditRoute: typeof ValueStoriesEditRoute
  VirtualReportsDetailsRoute: typeof VirtualReportsDetailsRoute
  WalkdownsDetailsRoute: typeof WalkdownsDetailsRoute
  WeldmapKestrelModelIdRoute: typeof WeldmapKestrelModelIdRoute
  Fallback_routeIndexRoute: typeof Fallback_routeIndexRoute
  AlertsIndexRoute: typeof AlertsIndexRoute
  AnomalyDetectionIndexRoute: typeof AnomalyDetectionIndexRoute
  AppConfigIndexRoute: typeof AppConfigIndexRoute
  AssetAssessmentIndexRoute: typeof AssetAssessmentIndexRoute
  AssetLensIndexRoute: typeof AssetLensIndexRoute
  AssetsIndexRoute: typeof AssetsIndexRoute
  BudgetingIndexRoute: typeof BudgetingIndexRoute
  CasesIndexRoute: typeof CasesIndexRoute
  DocumentViewerIndexRoute: typeof DocumentViewerIndexRoute
  DocumentsIndexRoute: typeof DocumentsIndexRoute
  DossiersIndexRoute: typeof DossiersIndexRoute
  EntryBrowserIndexRoute: typeof EntryBrowserIndexRoute
  ExtensionsIndexRoute: typeof ExtensionsIndexRoute
  FimIndexRoute: typeof FimIndexRoute
  FleetAnalysisIndexRoute: typeof FleetAnalysisIndexRoute
  FlightDataUploadIndexRoute: typeof FlightDataUploadIndexRoute
  HealthPlansIndexRoute: typeof HealthPlansIndexRoute
  HomeIndexRoute: typeof HomeIndexRoute
  InspectionsIndexRoute: typeof InspectionsIndexRoute
  JobIndexRoute: typeof JobIndexRoute
  LibraDashboardIndexRoute: typeof LibraDashboardIndexRoute
  LibraIndexRoute: typeof LibraIndexRoute
  LogbookIndexRoute: typeof LogbookIndexRoute
  MaximoIndexRoute: typeof MaximoIndexRoute
  NiiDashboardIndexRoute: typeof NiiDashboardIndexRoute
  NotificationsIndexRoute: typeof NotificationsIndexRoute
  OrganizationIndexRoute: typeof OrganizationIndexRoute
  OverviewIndexRoute: typeof OverviewIndexRoute
  PartsIndexRoute: typeof PartsIndexRoute
  PipelinesIndexRoute: typeof PipelinesIndexRoute
  PrismIndexRoute: typeof PrismIndexRoute
  ProcessDataIndexRoute: typeof ProcessDataIndexRoute
  ProcessFlowsIndexRoute: typeof ProcessFlowsIndexRoute
  ProductionDashboardIndexRoute: typeof ProductionDashboardIndexRoute
  ReportingIndexRoute: typeof ReportingIndexRoute
  SchedulingIndexRoute: typeof SchedulingIndexRoute
  ShipsIndexRoute: typeof ShipsIndexRoute
  SiteContextMonitoringIndexRoute: typeof SiteContextMonitoringIndexRoute
  SystemLensIndexRoute: typeof SystemLensIndexRoute
  UsersIndexRoute: typeof UsersIndexRoute
  ValueStoriesIndexRoute: typeof ValueStoriesIndexRoute
  ViewerRoutingIndexRoute: typeof ViewerRoutingIndexRoute
  ViewerIndexRoute: typeof ViewerIndexRoute
  VirtualReportsIndexRoute: typeof VirtualReportsIndexRoute
  WalkdownsIndexRoute: typeof WalkdownsIndexRoute
  WalkthroughIndexRoute: typeof WalkthroughIndexRoute
  WeldmapIndexRoute: typeof WeldmapIndexRoute
  deprecated_page_namesSiteViewSiteIDRoute: typeof deprecated_page_namesSiteViewSiteIDRoute
  Alertsdeprecated_routesSiteIDRoute: typeof Alertsdeprecated_routesSiteIDRoute
  AnomalyDetectiondeprecated_routesSiteIDRoute: typeof AnomalyDetectiondeprecated_routesSiteIDRouteWithChildren
  Assetsdeprecated_routesChar123SiteIDChar125Route: typeof Assetsdeprecated_routesChar123SiteIDChar125Route
  Assetssingle_asset_destinationsLifecycleRoute: typeof Assetssingle_asset_destinationsLifecycleRoute
  Assetssingle_asset_destinationsUnitRoute: typeof Assetssingle_asset_destinationsUnitRoute
  Budgetingdeprecated_routesSiteIDRoute: typeof Budgetingdeprecated_routesSiteIDRoute
  Casesdeprecated_routesSiteIDRoute: typeof Casesdeprecated_routesSiteIDRouteWithChildren
  Extensionsdeprecated_routesOrgIDRoute: typeof Extensionsdeprecated_routesOrgIDRoute
  FleetAnalysisdeprecated_routesSiteIDRoute: typeof FleetAnalysisdeprecated_routesSiteIDRoute
  FlightDataUploaddeprecated_routesSiteIDRoute: typeof FlightDataUploaddeprecated_routesSiteIDRoute
  HealthPlansdeprecated_routesSiteIDRoute: typeof HealthPlansdeprecated_routesSiteIDRoute
  Homedeprecated_routesChar123SiteIDChar125Route: typeof Homedeprecated_routesChar123SiteIDChar125Route
  Inspectionsdeprecated_routesSiteIDRoute: typeof Inspectionsdeprecated_routesSiteIDRoute
  Jobdeprecated_routesSiteIDRoute: typeof Jobdeprecated_routesSiteIDRoute
  LibraDashboarddeprecated_routesOrgIDRoute: typeof LibraDashboarddeprecated_routesOrgIDRouteWithChildren
  LogbookEntryLogEntryIdRoute: typeof LogbookEntryLogEntryIdRoute
  LogbookEntryNewRoute: typeof LogbookEntryNewRoute
  LogbookTemplatesTemplateIdRoute: typeof LogbookTemplatesTemplateIdRoute
  LogbookTemplatesNewRoute: typeof LogbookTemplatesNewRoute
  Maximodeprecated_routesSiteIDRoute: typeof Maximodeprecated_routesSiteIDRoute
  Organizationdeprecated_routesOrgIDRoute: typeof Organizationdeprecated_routesOrgIDRoute
  Overviewdeprecated_routesSiteIDRoute: typeof Overviewdeprecated_routesSiteIDRoute
  Partsdeprecated_routesSiteIDRoute: typeof Partsdeprecated_routesSiteIDRoute
  ProcessDataChartChartIDRoute: typeof ProcessDataChartChartIDRoute
  Schedulingdeprecated_routesSiteIDRoute: typeof Schedulingdeprecated_routesSiteIDRoute
  SystemLensdeprecated_routesSiteIDRoute: typeof SystemLensdeprecated_routesSiteIDRoute
  Usersdeprecated_routesOrgIDRoute: typeof Usersdeprecated_routesOrgIDRoute
  ViewerUnitIDConfigurationRoute: typeof ViewerUnitIDConfigurationRoute
  ViewerUnitIDInspectionRoute: typeof ViewerUnitIDInspectionRoute
  Walkthroughdeprecated_routesSiteIDRoute: typeof Walkthroughdeprecated_routesSiteIDRoute
  OrganizationSiteIndexRoute: typeof OrganizationSiteIndexRoute
  ViewerUnitIDIndexRoute: typeof ViewerUnitIDIndexRoute
  AssetAssessmentdeprecated_routesSiteIDChar123UnitIDChar125Route: typeof AssetAssessmentdeprecated_routesSiteIDChar123UnitIDChar125Route
  AssetLensdeprecated_routesSiteIDUnitIDRoute: typeof AssetLensdeprecated_routesSiteIDUnitIDRoute
  Assetsdeprecated_routesSiteIDUnitIDRoute: typeof Assetsdeprecated_routesSiteIDUnitIDRoute
  Libradeprecated_routesOrgIDChar123WorkflowIdChar125Route: typeof Libradeprecated_routesOrgIDChar123WorkflowIdChar125Route
  Organizationdeprecated_routesOrgIDSiteRoute: typeof Organizationdeprecated_routesOrgIDSiteRouteWithChildren
  Prismdeprecated_routesOrgIDEntryIdRoute: typeof Prismdeprecated_routesOrgIDEntryIdRoute
  ProcessDatadeprecated_routesSiteIDViewRoute: typeof ProcessDatadeprecated_routesSiteIDViewRoute
  ProcessFlowsdeprecated_routesSiteIDDiagramIDRoute: typeof ProcessFlowsdeprecated_routesSiteIDDiagramIDRoute
  Reportingdeprecated_routesSiteIDReportIDRoute: typeof Reportingdeprecated_routesSiteIDReportIDRoute
  Reportingdeprecated_routesSiteIDNewRoute: typeof Reportingdeprecated_routesSiteIDNewRoute
  ValueStoriesdeprecated_routesSiteIDAddRoute: typeof ValueStoriesdeprecated_routesSiteIDAddRoute
  VirtualReportsdeprecated_routesSiteIDComponentIDRoute: typeof VirtualReportsdeprecated_routesSiteIDComponentIDRoute
  Walkdownsdeprecated_routesSiteIDWalkdownIdRoute: typeof Walkdownsdeprecated_routesSiteIDWalkdownIdRoute
  ProcessDatadeprecated_routesSiteIDIndexRoute: typeof ProcessDatadeprecated_routesSiteIDIndexRoute
  ProcessFlowsdeprecated_routesSiteIDIndexRoute: typeof ProcessFlowsdeprecated_routesSiteIDIndexRoute
  Reportingdeprecated_routesSiteIDIndexRoute: typeof Reportingdeprecated_routesSiteIDIndexRoute
  Shipsdeprecated_routesSiteIDIndexRoute: typeof Shipsdeprecated_routesSiteIDIndexRoute
  ValueStoriesdeprecated_routesSiteIDIndexRoute: typeof ValueStoriesdeprecated_routesSiteIDIndexRoute
  VirtualReportsdeprecated_routesSiteIDIndexRoute: typeof VirtualReportsdeprecated_routesSiteIDIndexRoute
  Walkdownsdeprecated_routesSiteIDIndexRoute: typeof Walkdownsdeprecated_routesSiteIDIndexRoute
  ProcessDatadeprecated_routesSiteIDChartChartIDRoute: typeof ProcessDatadeprecated_routesSiteIDChartChartIDRoute
  ProductionDashboarddeprecated_routesOrgIDSiteIDConfigIDRoute: typeof ProductionDashboarddeprecated_routesOrgIDSiteIDConfigIDRoute
  ValueStoriesdeprecated_routesSiteIDValueStoryIDEditRoute: typeof ValueStoriesdeprecated_routesSiteIDValueStoryIDEditRoute
  ProductionDashboarddeprecated_routesOrgIDSiteIDIndexRoute: typeof ProductionDashboarddeprecated_routesOrgIDSiteIDIndexRoute
  ValueStoriesdeprecated_routesSiteIDValueStoryIDIndexRoute: typeof ValueStoriesdeprecated_routesSiteIDValueStoryIDIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/systemview': {
      id: '/systemview'
      path: '/systemview'
      fullPath: '/systemview'
      preLoaderRoute: typeof SystemviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reconstruction': {
      id: '/reconstruction'
      path: '/reconstruction'
      fullPath: '/reconstruction'
      preLoaderRoute: typeof ReconstructionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/okr-dashboard': {
      id: '/okr-dashboard'
      path: '/okr-dashboard'
      fullPath: '/okr-dashboard'
      preLoaderRoute: typeof OkrDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/landing': {
      id: '/landing'
      path: '/landing'
      fullPath: '/landing'
      preLoaderRoute: typeof LandingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kestrel': {
      id: '/kestrel'
      path: '/kestrel'
      fullPath: '/kestrel'
      preLoaderRoute: typeof KestrelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs': {
      id: '/jobs'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof JobsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/health-check': {
      id: '/health-check'
      path: '/health-check'
      fullPath: '/health-check'
      preLoaderRoute: typeof HealthCheckRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/aerospace-gvi': {
      id: '/aerospace-gvi'
      path: '/aerospace-gvi'
      fullPath: '/aerospace-gvi'
      preLoaderRoute: typeof AerospaceGviRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/point-cloud': {
      id: '/point-cloud'
      path: '/point-cloud'
      fullPath: '/point-cloud'
      preLoaderRoute: typeof PointCloudRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inspection-dashboard': {
      id: '/inspection-dashboard'
      path: '/inspection-dashboard'
      fullPath: '/inspection-dashboard'
      preLoaderRoute: typeof InspectionDashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explorer': {
      id: '/explorer'
      path: '/explorer'
      fullPath: '/explorer'
      preLoaderRoute: typeof ExplorerRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/availability-planning': {
      id: '/availability-planning'
      path: '/availability-planning'
      fullPath: '/availability-planning'
      preLoaderRoute: typeof AvailabilityPlanningRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/weldmap/': {
      id: '/weldmap/'
      path: '/weldmap'
      fullPath: '/weldmap/'
      preLoaderRoute: typeof WeldmapIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/walkthrough/': {
      id: '/walkthrough/'
      path: '/walkthrough'
      fullPath: '/walkthrough/'
      preLoaderRoute: typeof WalkthroughIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/walkdowns/': {
      id: '/walkdowns/'
      path: '/walkdowns'
      fullPath: '/walkdowns/'
      preLoaderRoute: typeof WalkdownsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/virtual-reports/': {
      id: '/virtual-reports/'
      path: '/virtual-reports'
      fullPath: '/virtual-reports/'
      preLoaderRoute: typeof VirtualReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/viewer/': {
      id: '/viewer/'
      path: '/viewer'
      fullPath: '/viewer/'
      preLoaderRoute: typeof ViewerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/viewer-routing/': {
      id: '/viewer-routing/'
      path: '/viewer-routing'
      fullPath: '/viewer-routing/'
      preLoaderRoute: typeof ViewerRoutingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/value-stories/': {
      id: '/value-stories/'
      path: '/value-stories'
      fullPath: '/value-stories/'
      preLoaderRoute: typeof ValueStoriesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/': {
      id: '/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system-lens/': {
      id: '/system-lens/'
      path: '/system-lens'
      fullPath: '/system-lens/'
      preLoaderRoute: typeof SystemLensIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/site-context-monitoring/': {
      id: '/site-context-monitoring/'
      path: '/site-context-monitoring'
      fullPath: '/site-context-monitoring/'
      preLoaderRoute: typeof SiteContextMonitoringIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ships/': {
      id: '/ships/'
      path: '/ships'
      fullPath: '/ships/'
      preLoaderRoute: typeof ShipsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scheduling/': {
      id: '/scheduling/'
      path: '/scheduling'
      fullPath: '/scheduling/'
      preLoaderRoute: typeof SchedulingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reporting/': {
      id: '/reporting/'
      path: '/reporting'
      fullPath: '/reporting/'
      preLoaderRoute: typeof ReportingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/production-dashboard/': {
      id: '/production-dashboard/'
      path: '/production-dashboard'
      fullPath: '/production-dashboard/'
      preLoaderRoute: typeof ProductionDashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/process-flows/': {
      id: '/process-flows/'
      path: '/process-flows'
      fullPath: '/process-flows/'
      preLoaderRoute: typeof ProcessFlowsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/process-data/': {
      id: '/process-data/'
      path: '/process-data'
      fullPath: '/process-data/'
      preLoaderRoute: typeof ProcessDataIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prism/': {
      id: '/prism/'
      path: '/prism'
      fullPath: '/prism/'
      preLoaderRoute: typeof PrismIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/point-cloud/': {
      id: '/point-cloud/'
      path: '/'
      fullPath: '/point-cloud/'
      preLoaderRoute: typeof PointCloudIndexRouteImport
      parentRoute: typeof PointCloudRouteRoute
    }
    '/pipelines/': {
      id: '/pipelines/'
      path: '/pipelines'
      fullPath: '/pipelines/'
      preLoaderRoute: typeof PipelinesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parts/': {
      id: '/parts/'
      path: '/parts'
      fullPath: '/parts/'
      preLoaderRoute: typeof PartsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/overview/': {
      id: '/overview/'
      path: '/overview'
      fullPath: '/overview/'
      preLoaderRoute: typeof OverviewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organization/': {
      id: '/organization/'
      path: '/organization'
      fullPath: '/organization/'
      preLoaderRoute: typeof OrganizationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications/': {
      id: '/notifications/'
      path: '/notifications'
      fullPath: '/notifications/'
      preLoaderRoute: typeof NotificationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/nii-dashboard/': {
      id: '/nii-dashboard/'
      path: '/nii-dashboard'
      fullPath: '/nii-dashboard/'
      preLoaderRoute: typeof NiiDashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maximo/': {
      id: '/maximo/'
      path: '/maximo'
      fullPath: '/maximo/'
      preLoaderRoute: typeof MaximoIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logbook/': {
      id: '/logbook/'
      path: '/logbook'
      fullPath: '/logbook/'
      preLoaderRoute: typeof LogbookIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/libra/': {
      id: '/libra/'
      path: '/libra'
      fullPath: '/libra/'
      preLoaderRoute: typeof LibraIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/libra-dashboard/': {
      id: '/libra-dashboard/'
      path: '/libra-dashboard'
      fullPath: '/libra-dashboard/'
      preLoaderRoute: typeof LibraDashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kestrel/': {
      id: '/kestrel/'
      path: '/'
      fullPath: '/kestrel/'
      preLoaderRoute: typeof KestrelIndexRouteImport
      parentRoute: typeof KestrelRoute
    }
    '/job/': {
      id: '/job/'
      path: '/job'
      fullPath: '/job/'
      preLoaderRoute: typeof JobIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inspections/': {
      id: '/inspections/'
      path: '/inspections'
      fullPath: '/inspections/'
      preLoaderRoute: typeof InspectionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inspection-dashboard/': {
      id: '/inspection-dashboard/'
      path: '/'
      fullPath: '/inspection-dashboard/'
      preLoaderRoute: typeof InspectionDashboardIndexRouteImport
      parentRoute: typeof InspectionDashboardRouteRoute
    }
    '/home/': {
      id: '/home/'
      path: '/home'
      fullPath: '/home/'
      preLoaderRoute: typeof HomeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/health-plans/': {
      id: '/health-plans/'
      path: '/health-plans'
      fullPath: '/health-plans/'
      preLoaderRoute: typeof HealthPlansIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flightDataUpload/': {
      id: '/flightDataUpload/'
      path: '/flightDataUpload'
      fullPath: '/flightDataUpload/'
      preLoaderRoute: typeof FlightDataUploadIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fleet-analysis/': {
      id: '/fleet-analysis/'
      path: '/fleet-analysis'
      fullPath: '/fleet-analysis/'
      preLoaderRoute: typeof FleetAnalysisIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fim/': {
      id: '/fim/'
      path: '/fim'
      fullPath: '/fim/'
      preLoaderRoute: typeof FimIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/extensions/': {
      id: '/extensions/'
      path: '/extensions'
      fullPath: '/extensions/'
      preLoaderRoute: typeof ExtensionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explorer/': {
      id: '/explorer/'
      path: '/'
      fullPath: '/explorer/'
      preLoaderRoute: typeof ExplorerIndexRouteImport
      parentRoute: typeof ExplorerRouteRoute
    }
    '/entry-browser/': {
      id: '/entry-browser/'
      path: '/entry-browser'
      fullPath: '/entry-browser/'
      preLoaderRoute: typeof EntryBrowserIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dossiers/': {
      id: '/dossiers/'
      path: '/dossiers'
      fullPath: '/dossiers/'
      preLoaderRoute: typeof DossiersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents/': {
      id: '/documents/'
      path: '/documents'
      fullPath: '/documents/'
      preLoaderRoute: typeof DocumentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/document-viewer/': {
      id: '/document-viewer/'
      path: '/document-viewer'
      fullPath: '/document-viewer/'
      preLoaderRoute: typeof DocumentViewerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cases/': {
      id: '/cases/'
      path: '/cases'
      fullPath: '/cases/'
      preLoaderRoute: typeof CasesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/budgeting/': {
      id: '/budgeting/'
      path: '/budgeting'
      fullPath: '/budgeting/'
      preLoaderRoute: typeof BudgetingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/availability-planning/': {
      id: '/availability-planning/'
      path: '/'
      fullPath: '/availability-planning/'
      preLoaderRoute: typeof AvailabilityPlanningIndexRouteImport
      parentRoute: typeof AvailabilityPlanningRouteRoute
    }
    '/assets/': {
      id: '/assets/'
      path: '/assets'
      fullPath: '/assets/'
      preLoaderRoute: typeof AssetsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/asset-lens/': {
      id: '/asset-lens/'
      path: '/asset-lens'
      fullPath: '/asset-lens/'
      preLoaderRoute: typeof AssetLensIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/asset-assessment/': {
      id: '/asset-assessment/'
      path: '/asset-assessment'
      fullPath: '/asset-assessment/'
      preLoaderRoute: typeof AssetAssessmentIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app-config/': {
      id: '/app-config/'
      path: '/app-config'
      fullPath: '/app-config/'
      preLoaderRoute: typeof AppConfigIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/anomaly-detection/': {
      id: '/anomaly-detection/'
      path: '/anomaly-detection'
      fullPath: '/anomaly-detection/'
      preLoaderRoute: typeof AnomalyDetectionIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/alerts/': {
      id: '/alerts/'
      path: '/alerts'
      fullPath: '/alerts/'
      preLoaderRoute: typeof AlertsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/aerospace-gvi/': {
      id: '/aerospace-gvi/'
      path: '/'
      fullPath: '/aerospace-gvi/'
      preLoaderRoute: typeof AerospaceGviIndexRouteImport
      parentRoute: typeof AerospaceGviRoute
    }
    '/_fallback_route/': {
      id: '/_fallback_route/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof Fallback_routeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/weldmap/$kestrelModelId': {
      id: '/weldmap/$kestrelModelId'
      path: '/weldmap/$kestrelModelId'
      fullPath: '/weldmap/$kestrelModelId'
      preLoaderRoute: typeof WeldmapKestrelModelIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/walkdowns/details': {
      id: '/walkdowns/details'
      path: '/walkdowns/details'
      fullPath: '/walkdowns/details'
      preLoaderRoute: typeof WalkdownsDetailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/virtual-reports/details': {
      id: '/virtual-reports/details'
      path: '/virtual-reports/details'
      fullPath: '/virtual-reports/details'
      preLoaderRoute: typeof VirtualReportsDetailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/value-stories/edit': {
      id: '/value-stories/edit'
      path: '/value-stories/edit'
      fullPath: '/value-stories/edit'
      preLoaderRoute: typeof ValueStoriesEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/value-stories/details': {
      id: '/value-stories/details'
      path: '/value-stories/details'
      fullPath: '/value-stories/details'
      preLoaderRoute: typeof ValueStoriesDetailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/value-stories/add': {
      id: '/value-stories/add'
      path: '/value-stories/add'
      fullPath: '/value-stories/add'
      preLoaderRoute: typeof ValueStoriesAddRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/systemview/$entryID': {
      id: '/systemview/$entryID'
      path: '/$entryID'
      fullPath: '/systemview/$entryID'
      preLoaderRoute: typeof SystemviewEntryIDRouteImport
      parentRoute: typeof SystemviewRoute
    }
    '/reporting/new': {
      id: '/reporting/new'
      path: '/reporting/new'
      fullPath: '/reporting/new'
      preLoaderRoute: typeof ReportingNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reporting/details': {
      id: '/reporting/details'
      path: '/reporting/details'
      fullPath: '/reporting/details'
      preLoaderRoute: typeof ReportingDetailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/production-dashboard/config': {
      id: '/production-dashboard/config'
      path: '/production-dashboard/config'
      fullPath: '/production-dashboard/config'
      preLoaderRoute: typeof ProductionDashboardConfigRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/process-flows/diagram': {
      id: '/process-flows/diagram'
      path: '/process-flows/diagram'
      fullPath: '/process-flows/diagram'
      preLoaderRoute: typeof ProcessFlowsDiagramRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/process-data/view': {
      id: '/process-data/view'
      path: '/process-data/view'
      fullPath: '/process-data/view'
      preLoaderRoute: typeof ProcessDataViewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/point-cloud/view': {
      id: '/point-cloud/view'
      path: '/view'
      fullPath: '/point-cloud/view'
      preLoaderRoute: typeof PointCloudViewRouteImport
      parentRoute: typeof PointCloudRouteRoute
    }
    '/kestrel/$kestrelRolodexEntry': {
      id: '/kestrel/$kestrelRolodexEntry'
      path: '/$kestrelRolodexEntry'
      fullPath: '/kestrel/$kestrelRolodexEntry'
      preLoaderRoute: typeof KestrelKestrelRolodexEntryRouteImport
      parentRoute: typeof KestrelRoute
    }
    '/inspection-dashboard/$orgOrSiteID': {
      id: '/inspection-dashboard/$orgOrSiteID'
      path: '/$orgOrSiteID'
      fullPath: '/inspection-dashboard/$orgOrSiteID'
      preLoaderRoute: typeof InspectionDashboardOrgOrSiteIDRouteImport
      parentRoute: typeof InspectionDashboardRouteRoute
    }
    '/forgings-indications/$inspectionId': {
      id: '/forgings-indications/$inspectionId'
      path: '/forgings-indications/$inspectionId'
      fullPath: '/forgings-indications/$inspectionId'
      preLoaderRoute: typeof ForgingsIndicationsInspectionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fim/review': {
      id: '/fim/review'
      path: '/fim/review'
      fullPath: '/fim/review'
      preLoaderRoute: typeof FimReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explorer/$orgOrSiteID': {
      id: '/explorer/$orgOrSiteID'
      path: '/$orgOrSiteID'
      fullPath: '/explorer/$orgOrSiteID'
      preLoaderRoute: typeof ExplorerOrgOrSiteIDRouteImport
      parentRoute: typeof ExplorerRouteRoute
    }
    '/documents/upload': {
      id: '/documents/upload'
      path: '/documents/upload'
      fullPath: '/documents/upload'
      preLoaderRoute: typeof DocumentsUploadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/details/$entryID': {
      id: '/details/$entryID'
      path: '/details/$entryID'
      fullPath: '/details/$entryID'
      preLoaderRoute: typeof DetailsEntryIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cases/edit': {
      id: '/cases/edit'
      path: '/cases/edit'
      fullPath: '/cases/edit'
      preLoaderRoute: typeof CasesEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cases/details': {
      id: '/cases/details'
      path: '/cases/details'
      fullPath: '/cases/details'
      preLoaderRoute: typeof CasesDetailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assets/routing': {
      id: '/assets/routing'
      path: '/assets/routing'
      fullPath: '/assets/routing'
      preLoaderRoute: typeof AssetsRoutingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/anomaly-detection/config': {
      id: '/anomaly-detection/config'
      path: '/anomaly-detection/config'
      fullPath: '/anomaly-detection/config'
      preLoaderRoute: typeof AnomalyDetectionConfigRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/alerts/details': {
      id: '/alerts/details'
      path: '/alerts/details'
      fullPath: '/alerts/details'
      preLoaderRoute: typeof AlertsDetailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/aerospace-gvi/$inspectionId': {
      id: '/aerospace-gvi/$inspectionId'
      path: '/$inspectionId'
      fullPath: '/aerospace-gvi/$inspectionId'
      preLoaderRoute: typeof AerospaceGviInspectionIdRouteImport
      parentRoute: typeof AerospaceGviRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/access': {
      id: '/admin/access'
      path: '/admin/access'
      fullPath: '/admin/access'
      preLoaderRoute: typeof AdminAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/viewer/$unitID/': {
      id: '/viewer/$unitID/'
      path: '/viewer/$unitID'
      fullPath: '/viewer/$unitID/'
      preLoaderRoute: typeof ViewerUnitIDIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organization_/site/': {
      id: '/organization_/site/'
      path: '/organization/site'
      fullPath: '/organization/site/'
      preLoaderRoute: typeof OrganizationSiteIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/walkthrough/(deprecated_routes)/$siteID': {
      id: '/walkthrough/(deprecated_routes)/$siteID'
      path: '/walkthrough/$siteID'
      fullPath: '/walkthrough/$siteID'
      preLoaderRoute: typeof Walkthroughdeprecated_routesSiteIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/viewer/$unitID/inspection': {
      id: '/viewer/$unitID/inspection'
      path: '/viewer/$unitID/inspection'
      fullPath: '/viewer/$unitID/inspection'
      preLoaderRoute: typeof ViewerUnitIDInspectionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/viewer/$unitID/configuration': {
      id: '/viewer/$unitID/configuration'
      path: '/viewer/$unitID/configuration'
      fullPath: '/viewer/$unitID/configuration'
      preLoaderRoute: typeof ViewerUnitIDConfigurationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/(deprecated_routes)/$orgID': {
      id: '/users/(deprecated_routes)/$orgID'
      path: '/users/$orgID'
      fullPath: '/users/$orgID'
      preLoaderRoute: typeof Usersdeprecated_routesOrgIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system-lens/(deprecated_routes)/$siteID': {
      id: '/system-lens/(deprecated_routes)/$siteID'
      path: '/system-lens/$siteID'
      fullPath: '/system-lens/$siteID'
      preLoaderRoute: typeof SystemLensdeprecated_routesSiteIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scheduling/(deprecated_routes)/$siteID': {
      id: '/scheduling/(deprecated_routes)/$siteID'
      path: '/scheduling/$siteID'
      fullPath: '/scheduling/$siteID'
      preLoaderRoute: typeof Schedulingdeprecated_routesSiteIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/process-data/chart/$chartID': {
      id: '/process-data/chart/$chartID'
      path: '/process-data/chart/$chartID'
      fullPath: '/process-data/chart/$chartID'
      preLoaderRoute: typeof ProcessDataChartChartIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parts/(deprecated_routes)/$siteID': {
      id: '/parts/(deprecated_routes)/$siteID'
      path: '/parts/$siteID'
      fullPath: '/parts/$siteID'
      preLoaderRoute: typeof Partsdeprecated_routesSiteIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/overview/(deprecated_routes)/$siteID': {
      id: '/overview/(deprecated_routes)/$siteID'
      path: '/overview/$siteID'
      fullPath: '/overview/$siteID'
      preLoaderRoute: typeof Overviewdeprecated_routesSiteIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organization/(deprecated_routes)/$orgID': {
      id: '/organization/(deprecated_routes)/$orgID'
      path: '/organization/$orgID'
      fullPath: '/organization/$orgID'
      preLoaderRoute: typeof Organizationdeprecated_routesOrgIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maximo/(deprecated_routes)/$siteID': {
      id: '/maximo/(deprecated_routes)/$siteID'
      path: '/maximo/$siteID'
      fullPath: '/maximo/$siteID'
      preLoaderRoute: typeof Maximodeprecated_routesSiteIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logbook/templates/new': {
      id: '/logbook/templates/new'
      path: '/logbook/templates/new'
      fullPath: '/logbook/templates/new'
      preLoaderRoute: typeof LogbookTemplatesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logbook/templates/$templateId': {
      id: '/logbook/templates/$templateId'
      path: '/logbook/templates/$templateId'
      fullPath: '/logbook/templates/$templateId'
      preLoaderRoute: typeof LogbookTemplatesTemplateIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logbook/entry/new': {
      id: '/logbook/entry/new'
      path: '/logbook/entry/new'
      fullPath: '/logbook/entry/new'
      preLoaderRoute: typeof LogbookEntryNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logbook/entry/$logEntryId': {
      id: '/logbook/entry/$logEntryId'
      path: '/logbook/entry/$logEntryId'
      fullPath: '/logbook/entry/$logEntryId'
      preLoaderRoute: typeof LogbookEntryLogEntryIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/libra-dashboard/(deprecated_routes)/$orgID': {
      id: '/libra-dashboard/(deprecated_routes)/$orgID'
      path: '/libra-dashboard/$orgID'
      fullPath: '/libra-dashboard/$orgID'
      preLoaderRoute: typeof LibraDashboarddeprecated_routesOrgIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/job/(deprecated_routes)/$siteID': {
      id: '/job/(deprecated_routes)/$siteID'
      path: '/job/$siteID'
      fullPath: '/job/$siteID'
      preLoaderRoute: typeof Jobdeprecated_routesSiteIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inspections/(deprecated_routes)/$siteID': {
      id: '/inspections/(deprecated_routes)/$siteID'
      path: '/inspections/$siteID'
      fullPath: '/inspections/$siteID'
      preLoaderRoute: typeof Inspectionsdeprecated_routesSiteIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home/(deprecated_routes)/{-$siteID}': {
      id: '/home/(deprecated_routes)/{-$siteID}'
      path: '/home/{-$siteID}'
      fullPath: '/home/{-$siteID}'
      preLoaderRoute: typeof Homedeprecated_routesChar123SiteIDChar125RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/health-plans/(deprecated_routes)/$siteID': {
      id: '/health-plans/(deprecated_routes)/$siteID'
      path: '/health-plans/$siteID'
      fullPath: '/health-plans/$siteID'
      preLoaderRoute: typeof HealthPlansdeprecated_routesSiteIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flightDataUpload/(deprecated_routes)/$siteID': {
      id: '/flightDataUpload/(deprecated_routes)/$siteID'
      path: '/flightDataUpload/$siteID'
      fullPath: '/flightDataUpload/$siteID'
      preLoaderRoute: typeof FlightDataUploaddeprecated_routesSiteIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fleet-analysis/(deprecated_routes)/$siteID': {
      id: '/fleet-analysis/(deprecated_routes)/$siteID'
      path: '/fleet-analysis/$siteID'
      fullPath: '/fleet-analysis/$siteID'
      preLoaderRoute: typeof FleetAnalysisdeprecated_routesSiteIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/extensions/(deprecated_routes)/$orgID': {
      id: '/extensions/(deprecated_routes)/$orgID'
      path: '/extensions/$orgID'
      fullPath: '/extensions/$orgID'
      preLoaderRoute: typeof Extensionsdeprecated_routesOrgIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cases/(deprecated_routes)/$siteID': {
      id: '/cases/(deprecated_routes)/$siteID'
      path: '/cases/$siteID'
      fullPath: '/cases/$siteID'
      preLoaderRoute: typeof Casesdeprecated_routesSiteIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/budgeting/(deprecated_routes)/$siteID': {
      id: '/budgeting/(deprecated_routes)/$siteID'
      path: '/budgeting/$siteID'
      fullPath: '/budgeting/$siteID'
      preLoaderRoute: typeof Budgetingdeprecated_routesSiteIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/availability-planning/(deprecated_routes)/$siteID': {
      id: '/availability-planning/(deprecated_routes)/$siteID'
      path: '/$siteID'
      fullPath: '/availability-planning/$siteID'
      preLoaderRoute: typeof AvailabilityPlanningdeprecated_routesSiteIDRouteImport
      parentRoute: typeof AvailabilityPlanningRouteRoute
    }
    '/assets/(single_asset_destinations)/unit': {
      id: '/assets/(single_asset_destinations)/unit'
      path: '/assets/unit'
      fullPath: '/assets/unit'
      preLoaderRoute: typeof Assetssingle_asset_destinationsUnitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assets/(single_asset_destinations)/lifecycle': {
      id: '/assets/(single_asset_destinations)/lifecycle'
      path: '/assets/lifecycle'
      fullPath: '/assets/lifecycle'
      preLoaderRoute: typeof Assetssingle_asset_destinationsLifecycleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assets/(deprecated_routes)/{-$siteID}': {
      id: '/assets/(deprecated_routes)/{-$siteID}'
      path: '/assets/{-$siteID}'
      fullPath: '/assets/{-$siteID}'
      preLoaderRoute: typeof Assetsdeprecated_routesChar123SiteIDChar125RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/anomaly-detection/(deprecated_routes)/$siteID': {
      id: '/anomaly-detection/(deprecated_routes)/$siteID'
      path: '/anomaly-detection/$siteID'
      fullPath: '/anomaly-detection/$siteID'
      preLoaderRoute: typeof AnomalyDetectiondeprecated_routesSiteIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/alerts/(deprecated_routes)/$siteID': {
      id: '/alerts/(deprecated_routes)/$siteID'
      path: '/alerts/$siteID'
      fullPath: '/alerts/$siteID'
      preLoaderRoute: typeof Alertsdeprecated_routesSiteIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(deprecated_page_names)/site-view/$siteID': {
      id: '/(deprecated_page_names)/site-view/$siteID'
      path: '/site-view/$siteID'
      fullPath: '/site-view/$siteID'
      preLoaderRoute: typeof deprecated_page_namesSiteViewSiteIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/walkdowns/(deprecated_routes)/$siteID/': {
      id: '/walkdowns/(deprecated_routes)/$siteID/'
      path: '/walkdowns/$siteID'
      fullPath: '/walkdowns/$siteID/'
      preLoaderRoute: typeof Walkdownsdeprecated_routesSiteIDIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/virtual-reports/(deprecated_routes)/$siteID/': {
      id: '/virtual-reports/(deprecated_routes)/$siteID/'
      path: '/virtual-reports/$siteID'
      fullPath: '/virtual-reports/$siteID/'
      preLoaderRoute: typeof VirtualReportsdeprecated_routesSiteIDIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/value-stories/(deprecated_routes)/$siteID/': {
      id: '/value-stories/(deprecated_routes)/$siteID/'
      path: '/value-stories/$siteID'
      fullPath: '/value-stories/$siteID/'
      preLoaderRoute: typeof ValueStoriesdeprecated_routesSiteIDIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ships/(deprecated_routes)/$siteID/': {
      id: '/ships/(deprecated_routes)/$siteID/'
      path: '/ships/$siteID'
      fullPath: '/ships/$siteID/'
      preLoaderRoute: typeof Shipsdeprecated_routesSiteIDIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reporting/(deprecated_routes)/$siteID/': {
      id: '/reporting/(deprecated_routes)/$siteID/'
      path: '/reporting/$siteID'
      fullPath: '/reporting/$siteID/'
      preLoaderRoute: typeof Reportingdeprecated_routesSiteIDIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/process-flows/(deprecated_routes)/$siteID/': {
      id: '/process-flows/(deprecated_routes)/$siteID/'
      path: '/process-flows/$siteID'
      fullPath: '/process-flows/$siteID/'
      preLoaderRoute: typeof ProcessFlowsdeprecated_routesSiteIDIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/process-data/(deprecated_routes)/$siteID/': {
      id: '/process-data/(deprecated_routes)/$siteID/'
      path: '/process-data/$siteID'
      fullPath: '/process-data/$siteID/'
      preLoaderRoute: typeof ProcessDatadeprecated_routesSiteIDIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/walkdowns/(deprecated_routes)/$siteID/$walkdownId': {
      id: '/walkdowns/(deprecated_routes)/$siteID/$walkdownId'
      path: '/walkdowns/$siteID/$walkdownId'
      fullPath: '/walkdowns/$siteID/$walkdownId'
      preLoaderRoute: typeof Walkdownsdeprecated_routesSiteIDWalkdownIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/virtual-reports/(deprecated_routes)/$siteID/$componentID': {
      id: '/virtual-reports/(deprecated_routes)/$siteID/$componentID'
      path: '/virtual-reports/$siteID/$componentID'
      fullPath: '/virtual-reports/$siteID/$componentID'
      preLoaderRoute: typeof VirtualReportsdeprecated_routesSiteIDComponentIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/value-stories/(deprecated_routes)/$siteID/add': {
      id: '/value-stories/(deprecated_routes)/$siteID/add'
      path: '/value-stories/$siteID/add'
      fullPath: '/value-stories/$siteID/add'
      preLoaderRoute: typeof ValueStoriesdeprecated_routesSiteIDAddRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reporting/(deprecated_routes)/$siteID/new': {
      id: '/reporting/(deprecated_routes)/$siteID/new'
      path: '/reporting/$siteID/new'
      fullPath: '/reporting/$siteID/new'
      preLoaderRoute: typeof Reportingdeprecated_routesSiteIDNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reporting/(deprecated_routes)/$siteID/$reportID': {
      id: '/reporting/(deprecated_routes)/$siteID/$reportID'
      path: '/reporting/$siteID/$reportID'
      fullPath: '/reporting/$siteID/$reportID'
      preLoaderRoute: typeof Reportingdeprecated_routesSiteIDReportIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/process-flows/(deprecated_routes)/$siteID/$diagramID': {
      id: '/process-flows/(deprecated_routes)/$siteID/$diagramID'
      path: '/process-flows/$siteID/$diagramID'
      fullPath: '/process-flows/$siteID/$diagramID'
      preLoaderRoute: typeof ProcessFlowsdeprecated_routesSiteIDDiagramIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/process-data/(deprecated_routes)/$siteID/view': {
      id: '/process-data/(deprecated_routes)/$siteID/view'
      path: '/process-data/$siteID/view'
      fullPath: '/process-data/$siteID/view'
      preLoaderRoute: typeof ProcessDatadeprecated_routesSiteIDViewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prism/(deprecated_routes)/$orgID/$entryId': {
      id: '/prism/(deprecated_routes)/$orgID/$entryId'
      path: '/prism/$orgID/$entryId'
      fullPath: '/prism/$orgID/$entryId'
      preLoaderRoute: typeof Prismdeprecated_routesOrgIDEntryIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/point-cloud/(deprecated_routes)/$siteID/{-$pointCloudOrSceneID}': {
      id: '/point-cloud/(deprecated_routes)/$siteID/{-$pointCloudOrSceneID}'
      path: '/$siteID/{-$pointCloudOrSceneID}'
      fullPath: '/point-cloud/$siteID/{-$pointCloudOrSceneID}'
      preLoaderRoute: typeof PointClouddeprecated_routesSiteIDChar123PointCloudOrSceneIDChar125RouteImport
      parentRoute: typeof PointCloudRouteRoute
    }
    '/organization_/(deprecated_routes)/$orgID/site': {
      id: '/organization_/(deprecated_routes)/$orgID/site'
      path: '/organization/$orgID/site'
      fullPath: '/organization/$orgID/site'
      preLoaderRoute: typeof Organizationdeprecated_routesOrgIDSiteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/libra/(deprecated_routes)/$orgID/{-$workflowId}': {
      id: '/libra/(deprecated_routes)/$orgID/{-$workflowId}'
      path: '/libra/$orgID/{-$workflowId}'
      fullPath: '/libra/$orgID/{-$workflowId}'
      preLoaderRoute: typeof Libradeprecated_routesOrgIDChar123WorkflowIdChar125RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/libra-dashboard/(deprecated_routes)/$orgID/$dashboardConfigId': {
      id: '/libra-dashboard/(deprecated_routes)/$orgID/$dashboardConfigId'
      path: '/$dashboardConfigId'
      fullPath: '/libra-dashboard/$orgID/$dashboardConfigId'
      preLoaderRoute: typeof LibraDashboarddeprecated_routesOrgIDDashboardConfigIdRouteImport
      parentRoute: typeof LibraDashboarddeprecated_routesOrgIDRoute
    }
    '/kestrel/forms/$inspectionType/$formName': {
      id: '/kestrel/forms/$inspectionType/$formName'
      path: '/forms/$inspectionType/$formName'
      fullPath: '/kestrel/forms/$inspectionType/$formName'
      preLoaderRoute: typeof KestrelFormsInspectionTypeFormNameRouteImport
      parentRoute: typeof KestrelRoute
    }
    '/cases/(deprecated_routes)/$siteID/$caseID': {
      id: '/cases/(deprecated_routes)/$siteID/$caseID'
      path: '/$caseID'
      fullPath: '/cases/$siteID/$caseID'
      preLoaderRoute: typeof Casesdeprecated_routesSiteIDCaseIDRouteImport
      parentRoute: typeof Casesdeprecated_routesSiteIDRoute
    }
    '/availability-planning/(deprecated_routes)/$siteID/$shipID': {
      id: '/availability-planning/(deprecated_routes)/$siteID/$shipID'
      path: '/$shipID'
      fullPath: '/availability-planning/$siteID/$shipID'
      preLoaderRoute: typeof AvailabilityPlanningdeprecated_routesSiteIDShipIDRouteImport
      parentRoute: typeof AvailabilityPlanningdeprecated_routesSiteIDRoute
    }
    '/assets/(deprecated_routes)/$siteID/$unitID': {
      id: '/assets/(deprecated_routes)/$siteID/$unitID'
      path: '/assets/$siteID/$unitID'
      fullPath: '/assets/$siteID/$unitID'
      preLoaderRoute: typeof Assetsdeprecated_routesSiteIDUnitIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/asset-lens/(deprecated_routes)/$siteID/$unitID': {
      id: '/asset-lens/(deprecated_routes)/$siteID/$unitID'
      path: '/asset-lens/$siteID/$unitID'
      fullPath: '/asset-lens/$siteID/$unitID'
      preLoaderRoute: typeof AssetLensdeprecated_routesSiteIDUnitIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/asset-assessment/(deprecated_routes)/$siteID/{-$unitID}': {
      id: '/asset-assessment/(deprecated_routes)/$siteID/{-$unitID}'
      path: '/asset-assessment/$siteID/{-$unitID}'
      fullPath: '/asset-assessment/$siteID/{-$unitID}'
      preLoaderRoute: typeof AssetAssessmentdeprecated_routesSiteIDChar123UnitIDChar125RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/anomaly-detection/(deprecated_routes)/$siteID/$detectionConfigurationId': {
      id: '/anomaly-detection/(deprecated_routes)/$siteID/$detectionConfigurationId'
      path: '/$detectionConfigurationId'
      fullPath: '/anomaly-detection/$siteID/$detectionConfigurationId'
      preLoaderRoute: typeof AnomalyDetectiondeprecated_routesSiteIDDetectionConfigurationIdRouteImport
      parentRoute: typeof AnomalyDetectiondeprecated_routesSiteIDRoute
    }
    '/value-stories/(deprecated_routes)/$siteID/$valueStoryID/': {
      id: '/value-stories/(deprecated_routes)/$siteID/$valueStoryID/'
      path: '/value-stories/$siteID/$valueStoryID'
      fullPath: '/value-stories/$siteID/$valueStoryID/'
      preLoaderRoute: typeof ValueStoriesdeprecated_routesSiteIDValueStoryIDIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/production-dashboard/(deprecated_routes)/$orgID/$siteID/': {
      id: '/production-dashboard/(deprecated_routes)/$orgID/$siteID/'
      path: '/production-dashboard/$orgID/$siteID'
      fullPath: '/production-dashboard/$orgID/$siteID/'
      preLoaderRoute: typeof ProductionDashboarddeprecated_routesOrgIDSiteIDIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/value-stories/(deprecated_routes)/$siteID/$valueStoryID/edit': {
      id: '/value-stories/(deprecated_routes)/$siteID/$valueStoryID/edit'
      path: '/value-stories/$siteID/$valueStoryID/edit'
      fullPath: '/value-stories/$siteID/$valueStoryID/edit'
      preLoaderRoute: typeof ValueStoriesdeprecated_routesSiteIDValueStoryIDEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/production-dashboard/(deprecated_routes)/$orgID/$siteID/$configID': {
      id: '/production-dashboard/(deprecated_routes)/$orgID/$siteID/$configID'
      path: '/production-dashboard/$orgID/$siteID/$configID'
      fullPath: '/production-dashboard/$orgID/$siteID/$configID'
      preLoaderRoute: typeof ProductionDashboarddeprecated_routesOrgIDSiteIDConfigIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/process-data/(deprecated_routes)/$siteID/chart/$chartID': {
      id: '/process-data/(deprecated_routes)/$siteID/chart/$chartID'
      path: '/process-data/$siteID/chart/$chartID'
      fullPath: '/process-data/$siteID/chart/$chartID'
      preLoaderRoute: typeof ProcessDatadeprecated_routesSiteIDChartChartIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organization_/(deprecated_routes)/$orgID/site/$siteID': {
      id: '/organization_/(deprecated_routes)/$orgID/site/$siteID'
      path: '/$siteID'
      fullPath: '/organization/$orgID/site/$siteID'
      preLoaderRoute: typeof Organizationdeprecated_routesOrgIDSiteSiteIDRouteImport
      parentRoute: typeof Organizationdeprecated_routesOrgIDSiteRoute
    }
    '/cases/(deprecated_routes)/$siteID/edit/$caseID': {
      id: '/cases/(deprecated_routes)/$siteID/edit/$caseID'
      path: '/edit/$caseID'
      fullPath: '/cases/$siteID/edit/$caseID'
      preLoaderRoute: typeof Casesdeprecated_routesSiteIDEditCaseIDRouteImport
      parentRoute: typeof Casesdeprecated_routesSiteIDRoute
    }
  }
}

interface AvailabilityPlanningdeprecated_routesSiteIDRouteChildren {
  AvailabilityPlanningdeprecated_routesSiteIDShipIDRoute: typeof AvailabilityPlanningdeprecated_routesSiteIDShipIDRoute
}

const AvailabilityPlanningdeprecated_routesSiteIDRouteChildren: AvailabilityPlanningdeprecated_routesSiteIDRouteChildren =
  {
    AvailabilityPlanningdeprecated_routesSiteIDShipIDRoute:
      AvailabilityPlanningdeprecated_routesSiteIDShipIDRoute,
  }

const AvailabilityPlanningdeprecated_routesSiteIDRouteWithChildren =
  AvailabilityPlanningdeprecated_routesSiteIDRoute._addFileChildren(
    AvailabilityPlanningdeprecated_routesSiteIDRouteChildren,
  )

interface AvailabilityPlanningRouteRouteChildren {
  AvailabilityPlanningIndexRoute: typeof AvailabilityPlanningIndexRoute
  AvailabilityPlanningdeprecated_routesSiteIDRoute: typeof AvailabilityPlanningdeprecated_routesSiteIDRouteWithChildren
}

const AvailabilityPlanningRouteRouteChildren: AvailabilityPlanningRouteRouteChildren =
  {
    AvailabilityPlanningIndexRoute: AvailabilityPlanningIndexRoute,
    AvailabilityPlanningdeprecated_routesSiteIDRoute:
      AvailabilityPlanningdeprecated_routesSiteIDRouteWithChildren,
  }

const AvailabilityPlanningRouteRouteWithChildren =
  AvailabilityPlanningRouteRoute._addFileChildren(
    AvailabilityPlanningRouteRouteChildren,
  )

interface ExplorerRouteRouteChildren {
  ExplorerOrgOrSiteIDRoute: typeof ExplorerOrgOrSiteIDRoute
  ExplorerIndexRoute: typeof ExplorerIndexRoute
}

const ExplorerRouteRouteChildren: ExplorerRouteRouteChildren = {
  ExplorerOrgOrSiteIDRoute: ExplorerOrgOrSiteIDRoute,
  ExplorerIndexRoute: ExplorerIndexRoute,
}

const ExplorerRouteRouteWithChildren = ExplorerRouteRoute._addFileChildren(
  ExplorerRouteRouteChildren,
)

interface InspectionDashboardRouteRouteChildren {
  InspectionDashboardOrgOrSiteIDRoute: typeof InspectionDashboardOrgOrSiteIDRoute
  InspectionDashboardIndexRoute: typeof InspectionDashboardIndexRoute
}

const InspectionDashboardRouteRouteChildren: InspectionDashboardRouteRouteChildren =
  {
    InspectionDashboardOrgOrSiteIDRoute: InspectionDashboardOrgOrSiteIDRoute,
    InspectionDashboardIndexRoute: InspectionDashboardIndexRoute,
  }

const InspectionDashboardRouteRouteWithChildren =
  InspectionDashboardRouteRoute._addFileChildren(
    InspectionDashboardRouteRouteChildren,
  )

interface PointCloudRouteRouteChildren {
  PointCloudViewRoute: typeof PointCloudViewRoute
  PointCloudIndexRoute: typeof PointCloudIndexRoute
  PointClouddeprecated_routesSiteIDChar123PointCloudOrSceneIDChar125Route: typeof PointClouddeprecated_routesSiteIDChar123PointCloudOrSceneIDChar125Route
}

const PointCloudRouteRouteChildren: PointCloudRouteRouteChildren = {
  PointCloudViewRoute: PointCloudViewRoute,
  PointCloudIndexRoute: PointCloudIndexRoute,
  PointClouddeprecated_routesSiteIDChar123PointCloudOrSceneIDChar125Route:
    PointClouddeprecated_routesSiteIDChar123PointCloudOrSceneIDChar125Route,
}

const PointCloudRouteRouteWithChildren = PointCloudRouteRoute._addFileChildren(
  PointCloudRouteRouteChildren,
)

interface AerospaceGviRouteChildren {
  AerospaceGviInspectionIdRoute: typeof AerospaceGviInspectionIdRoute
  AerospaceGviIndexRoute: typeof AerospaceGviIndexRoute
}

const AerospaceGviRouteChildren: AerospaceGviRouteChildren = {
  AerospaceGviInspectionIdRoute: AerospaceGviInspectionIdRoute,
  AerospaceGviIndexRoute: AerospaceGviIndexRoute,
}

const AerospaceGviRouteWithChildren = AerospaceGviRoute._addFileChildren(
  AerospaceGviRouteChildren,
)

interface KestrelRouteChildren {
  KestrelKestrelRolodexEntryRoute: typeof KestrelKestrelRolodexEntryRoute
  KestrelIndexRoute: typeof KestrelIndexRoute
  KestrelFormsInspectionTypeFormNameRoute: typeof KestrelFormsInspectionTypeFormNameRoute
}

const KestrelRouteChildren: KestrelRouteChildren = {
  KestrelKestrelRolodexEntryRoute: KestrelKestrelRolodexEntryRoute,
  KestrelIndexRoute: KestrelIndexRoute,
  KestrelFormsInspectionTypeFormNameRoute:
    KestrelFormsInspectionTypeFormNameRoute,
}

const KestrelRouteWithChildren =
  KestrelRoute._addFileChildren(KestrelRouteChildren)

interface SystemviewRouteChildren {
  SystemviewEntryIDRoute: typeof SystemviewEntryIDRoute
}

const SystemviewRouteChildren: SystemviewRouteChildren = {
  SystemviewEntryIDRoute: SystemviewEntryIDRoute,
}

const SystemviewRouteWithChildren = SystemviewRoute._addFileChildren(
  SystemviewRouteChildren,
)

interface AnomalyDetectiondeprecated_routesSiteIDRouteChildren {
  AnomalyDetectiondeprecated_routesSiteIDDetectionConfigurationIdRoute: typeof AnomalyDetectiondeprecated_routesSiteIDDetectionConfigurationIdRoute
}

const AnomalyDetectiondeprecated_routesSiteIDRouteChildren: AnomalyDetectiondeprecated_routesSiteIDRouteChildren =
  {
    AnomalyDetectiondeprecated_routesSiteIDDetectionConfigurationIdRoute:
      AnomalyDetectiondeprecated_routesSiteIDDetectionConfigurationIdRoute,
  }

const AnomalyDetectiondeprecated_routesSiteIDRouteWithChildren =
  AnomalyDetectiondeprecated_routesSiteIDRoute._addFileChildren(
    AnomalyDetectiondeprecated_routesSiteIDRouteChildren,
  )

interface Casesdeprecated_routesSiteIDRouteChildren {
  Casesdeprecated_routesSiteIDCaseIDRoute: typeof Casesdeprecated_routesSiteIDCaseIDRoute
  Casesdeprecated_routesSiteIDEditCaseIDRoute: typeof Casesdeprecated_routesSiteIDEditCaseIDRoute
}

const Casesdeprecated_routesSiteIDRouteChildren: Casesdeprecated_routesSiteIDRouteChildren =
  {
    Casesdeprecated_routesSiteIDCaseIDRoute:
      Casesdeprecated_routesSiteIDCaseIDRoute,
    Casesdeprecated_routesSiteIDEditCaseIDRoute:
      Casesdeprecated_routesSiteIDEditCaseIDRoute,
  }

const Casesdeprecated_routesSiteIDRouteWithChildren =
  Casesdeprecated_routesSiteIDRoute._addFileChildren(
    Casesdeprecated_routesSiteIDRouteChildren,
  )

interface LibraDashboarddeprecated_routesOrgIDRouteChildren {
  LibraDashboarddeprecated_routesOrgIDDashboardConfigIdRoute: typeof LibraDashboarddeprecated_routesOrgIDDashboardConfigIdRoute
}

const LibraDashboarddeprecated_routesOrgIDRouteChildren: LibraDashboarddeprecated_routesOrgIDRouteChildren =
  {
    LibraDashboarddeprecated_routesOrgIDDashboardConfigIdRoute:
      LibraDashboarddeprecated_routesOrgIDDashboardConfigIdRoute,
  }

const LibraDashboarddeprecated_routesOrgIDRouteWithChildren =
  LibraDashboarddeprecated_routesOrgIDRoute._addFileChildren(
    LibraDashboarddeprecated_routesOrgIDRouteChildren,
  )

interface Organizationdeprecated_routesOrgIDSiteRouteChildren {
  Organizationdeprecated_routesOrgIDSiteSiteIDRoute: typeof Organizationdeprecated_routesOrgIDSiteSiteIDRoute
}

const Organizationdeprecated_routesOrgIDSiteRouteChildren: Organizationdeprecated_routesOrgIDSiteRouteChildren =
  {
    Organizationdeprecated_routesOrgIDSiteSiteIDRoute:
      Organizationdeprecated_routesOrgIDSiteSiteIDRoute,
  }

const Organizationdeprecated_routesOrgIDSiteRouteWithChildren =
  Organizationdeprecated_routesOrgIDSiteRoute._addFileChildren(
    Organizationdeprecated_routesOrgIDSiteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  AvailabilityPlanningRouteRoute: AvailabilityPlanningRouteRouteWithChildren,
  ExplorerRouteRoute: ExplorerRouteRouteWithChildren,
  InspectionDashboardRouteRoute: InspectionDashboardRouteRouteWithChildren,
  PointCloudRouteRoute: PointCloudRouteRouteWithChildren,
  AerospaceGviRoute: AerospaceGviRouteWithChildren,
  HealthCheckRoute: HealthCheckRoute,
  JobsRoute: JobsRoute,
  KestrelRoute: KestrelRouteWithChildren,
  LandingRoute: LandingRoute,
  OkrDashboardRoute: OkrDashboardRoute,
  ReconstructionRoute: ReconstructionRoute,
  SystemviewRoute: SystemviewRouteWithChildren,
  AdminAccessRoute: AdminAccessRoute,
  AdminUsersRoute: AdminUsersRoute,
  AlertsDetailsRoute: AlertsDetailsRoute,
  AnomalyDetectionConfigRoute: AnomalyDetectionConfigRoute,
  AssetsRoutingRoute: AssetsRoutingRoute,
  CasesDetailsRoute: CasesDetailsRoute,
  CasesEditRoute: CasesEditRoute,
  DetailsEntryIDRoute: DetailsEntryIDRoute,
  DocumentsUploadRoute: DocumentsUploadRoute,
  FimReviewRoute: FimReviewRoute,
  ForgingsIndicationsInspectionIdRoute: ForgingsIndicationsInspectionIdRoute,
  ProcessDataViewRoute: ProcessDataViewRoute,
  ProcessFlowsDiagramRoute: ProcessFlowsDiagramRoute,
  ProductionDashboardConfigRoute: ProductionDashboardConfigRoute,
  ReportingDetailsRoute: ReportingDetailsRoute,
  ReportingNewRoute: ReportingNewRoute,
  ValueStoriesAddRoute: ValueStoriesAddRoute,
  ValueStoriesDetailsRoute: ValueStoriesDetailsRoute,
  ValueStoriesEditRoute: ValueStoriesEditRoute,
  VirtualReportsDetailsRoute: VirtualReportsDetailsRoute,
  WalkdownsDetailsRoute: WalkdownsDetailsRoute,
  WeldmapKestrelModelIdRoute: WeldmapKestrelModelIdRoute,
  Fallback_routeIndexRoute: Fallback_routeIndexRoute,
  AlertsIndexRoute: AlertsIndexRoute,
  AnomalyDetectionIndexRoute: AnomalyDetectionIndexRoute,
  AppConfigIndexRoute: AppConfigIndexRoute,
  AssetAssessmentIndexRoute: AssetAssessmentIndexRoute,
  AssetLensIndexRoute: AssetLensIndexRoute,
  AssetsIndexRoute: AssetsIndexRoute,
  BudgetingIndexRoute: BudgetingIndexRoute,
  CasesIndexRoute: CasesIndexRoute,
  DocumentViewerIndexRoute: DocumentViewerIndexRoute,
  DocumentsIndexRoute: DocumentsIndexRoute,
  DossiersIndexRoute: DossiersIndexRoute,
  EntryBrowserIndexRoute: EntryBrowserIndexRoute,
  ExtensionsIndexRoute: ExtensionsIndexRoute,
  FimIndexRoute: FimIndexRoute,
  FleetAnalysisIndexRoute: FleetAnalysisIndexRoute,
  FlightDataUploadIndexRoute: FlightDataUploadIndexRoute,
  HealthPlansIndexRoute: HealthPlansIndexRoute,
  HomeIndexRoute: HomeIndexRoute,
  InspectionsIndexRoute: InspectionsIndexRoute,
  JobIndexRoute: JobIndexRoute,
  LibraDashboardIndexRoute: LibraDashboardIndexRoute,
  LibraIndexRoute: LibraIndexRoute,
  LogbookIndexRoute: LogbookIndexRoute,
  MaximoIndexRoute: MaximoIndexRoute,
  NiiDashboardIndexRoute: NiiDashboardIndexRoute,
  NotificationsIndexRoute: NotificationsIndexRoute,
  OrganizationIndexRoute: OrganizationIndexRoute,
  OverviewIndexRoute: OverviewIndexRoute,
  PartsIndexRoute: PartsIndexRoute,
  PipelinesIndexRoute: PipelinesIndexRoute,
  PrismIndexRoute: PrismIndexRoute,
  ProcessDataIndexRoute: ProcessDataIndexRoute,
  ProcessFlowsIndexRoute: ProcessFlowsIndexRoute,
  ProductionDashboardIndexRoute: ProductionDashboardIndexRoute,
  ReportingIndexRoute: ReportingIndexRoute,
  SchedulingIndexRoute: SchedulingIndexRoute,
  ShipsIndexRoute: ShipsIndexRoute,
  SiteContextMonitoringIndexRoute: SiteContextMonitoringIndexRoute,
  SystemLensIndexRoute: SystemLensIndexRoute,
  UsersIndexRoute: UsersIndexRoute,
  ValueStoriesIndexRoute: ValueStoriesIndexRoute,
  ViewerRoutingIndexRoute: ViewerRoutingIndexRoute,
  ViewerIndexRoute: ViewerIndexRoute,
  VirtualReportsIndexRoute: VirtualReportsIndexRoute,
  WalkdownsIndexRoute: WalkdownsIndexRoute,
  WalkthroughIndexRoute: WalkthroughIndexRoute,
  WeldmapIndexRoute: WeldmapIndexRoute,
  deprecated_page_namesSiteViewSiteIDRoute:
    deprecated_page_namesSiteViewSiteIDRoute,
  Alertsdeprecated_routesSiteIDRoute: Alertsdeprecated_routesSiteIDRoute,
  AnomalyDetectiondeprecated_routesSiteIDRoute:
    AnomalyDetectiondeprecated_routesSiteIDRouteWithChildren,
  Assetsdeprecated_routesChar123SiteIDChar125Route:
    Assetsdeprecated_routesChar123SiteIDChar125Route,
  Assetssingle_asset_destinationsLifecycleRoute:
    Assetssingle_asset_destinationsLifecycleRoute,
  Assetssingle_asset_destinationsUnitRoute:
    Assetssingle_asset_destinationsUnitRoute,
  Budgetingdeprecated_routesSiteIDRoute: Budgetingdeprecated_routesSiteIDRoute,
  Casesdeprecated_routesSiteIDRoute:
    Casesdeprecated_routesSiteIDRouteWithChildren,
  Extensionsdeprecated_routesOrgIDRoute: Extensionsdeprecated_routesOrgIDRoute,
  FleetAnalysisdeprecated_routesSiteIDRoute:
    FleetAnalysisdeprecated_routesSiteIDRoute,
  FlightDataUploaddeprecated_routesSiteIDRoute:
    FlightDataUploaddeprecated_routesSiteIDRoute,
  HealthPlansdeprecated_routesSiteIDRoute:
    HealthPlansdeprecated_routesSiteIDRoute,
  Homedeprecated_routesChar123SiteIDChar125Route:
    Homedeprecated_routesChar123SiteIDChar125Route,
  Inspectionsdeprecated_routesSiteIDRoute:
    Inspectionsdeprecated_routesSiteIDRoute,
  Jobdeprecated_routesSiteIDRoute: Jobdeprecated_routesSiteIDRoute,
  LibraDashboarddeprecated_routesOrgIDRoute:
    LibraDashboarddeprecated_routesOrgIDRouteWithChildren,
  LogbookEntryLogEntryIdRoute: LogbookEntryLogEntryIdRoute,
  LogbookEntryNewRoute: LogbookEntryNewRoute,
  LogbookTemplatesTemplateIdRoute: LogbookTemplatesTemplateIdRoute,
  LogbookTemplatesNewRoute: LogbookTemplatesNewRoute,
  Maximodeprecated_routesSiteIDRoute: Maximodeprecated_routesSiteIDRoute,
  Organizationdeprecated_routesOrgIDRoute:
    Organizationdeprecated_routesOrgIDRoute,
  Overviewdeprecated_routesSiteIDRoute: Overviewdeprecated_routesSiteIDRoute,
  Partsdeprecated_routesSiteIDRoute: Partsdeprecated_routesSiteIDRoute,
  ProcessDataChartChartIDRoute: ProcessDataChartChartIDRoute,
  Schedulingdeprecated_routesSiteIDRoute:
    Schedulingdeprecated_routesSiteIDRoute,
  SystemLensdeprecated_routesSiteIDRoute:
    SystemLensdeprecated_routesSiteIDRoute,
  Usersdeprecated_routesOrgIDRoute: Usersdeprecated_routesOrgIDRoute,
  ViewerUnitIDConfigurationRoute: ViewerUnitIDConfigurationRoute,
  ViewerUnitIDInspectionRoute: ViewerUnitIDInspectionRoute,
  Walkthroughdeprecated_routesSiteIDRoute:
    Walkthroughdeprecated_routesSiteIDRoute,
  OrganizationSiteIndexRoute: OrganizationSiteIndexRoute,
  ViewerUnitIDIndexRoute: ViewerUnitIDIndexRoute,
  AssetAssessmentdeprecated_routesSiteIDChar123UnitIDChar125Route:
    AssetAssessmentdeprecated_routesSiteIDChar123UnitIDChar125Route,
  AssetLensdeprecated_routesSiteIDUnitIDRoute:
    AssetLensdeprecated_routesSiteIDUnitIDRoute,
  Assetsdeprecated_routesSiteIDUnitIDRoute:
    Assetsdeprecated_routesSiteIDUnitIDRoute,
  Libradeprecated_routesOrgIDChar123WorkflowIdChar125Route:
    Libradeprecated_routesOrgIDChar123WorkflowIdChar125Route,
  Organizationdeprecated_routesOrgIDSiteRoute:
    Organizationdeprecated_routesOrgIDSiteRouteWithChildren,
  Prismdeprecated_routesOrgIDEntryIdRoute:
    Prismdeprecated_routesOrgIDEntryIdRoute,
  ProcessDatadeprecated_routesSiteIDViewRoute:
    ProcessDatadeprecated_routesSiteIDViewRoute,
  ProcessFlowsdeprecated_routesSiteIDDiagramIDRoute:
    ProcessFlowsdeprecated_routesSiteIDDiagramIDRoute,
  Reportingdeprecated_routesSiteIDReportIDRoute:
    Reportingdeprecated_routesSiteIDReportIDRoute,
  Reportingdeprecated_routesSiteIDNewRoute:
    Reportingdeprecated_routesSiteIDNewRoute,
  ValueStoriesdeprecated_routesSiteIDAddRoute:
    ValueStoriesdeprecated_routesSiteIDAddRoute,
  VirtualReportsdeprecated_routesSiteIDComponentIDRoute:
    VirtualReportsdeprecated_routesSiteIDComponentIDRoute,
  Walkdownsdeprecated_routesSiteIDWalkdownIdRoute:
    Walkdownsdeprecated_routesSiteIDWalkdownIdRoute,
  ProcessDatadeprecated_routesSiteIDIndexRoute:
    ProcessDatadeprecated_routesSiteIDIndexRoute,
  ProcessFlowsdeprecated_routesSiteIDIndexRoute:
    ProcessFlowsdeprecated_routesSiteIDIndexRoute,
  Reportingdeprecated_routesSiteIDIndexRoute:
    Reportingdeprecated_routesSiteIDIndexRoute,
  Shipsdeprecated_routesSiteIDIndexRoute:
    Shipsdeprecated_routesSiteIDIndexRoute,
  ValueStoriesdeprecated_routesSiteIDIndexRoute:
    ValueStoriesdeprecated_routesSiteIDIndexRoute,
  VirtualReportsdeprecated_routesSiteIDIndexRoute:
    VirtualReportsdeprecated_routesSiteIDIndexRoute,
  Walkdownsdeprecated_routesSiteIDIndexRoute:
    Walkdownsdeprecated_routesSiteIDIndexRoute,
  ProcessDatadeprecated_routesSiteIDChartChartIDRoute:
    ProcessDatadeprecated_routesSiteIDChartChartIDRoute,
  ProductionDashboarddeprecated_routesOrgIDSiteIDConfigIDRoute:
    ProductionDashboarddeprecated_routesOrgIDSiteIDConfigIDRoute,
  ValueStoriesdeprecated_routesSiteIDValueStoryIDEditRoute:
    ValueStoriesdeprecated_routesSiteIDValueStoryIDEditRoute,
  ProductionDashboarddeprecated_routesOrgIDSiteIDIndexRoute:
    ProductionDashboarddeprecated_routesOrgIDSiteIDIndexRoute,
  ValueStoriesdeprecated_routesSiteIDValueStoryIDIndexRoute:
    ValueStoriesdeprecated_routesSiteIDValueStoryIDIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
